import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import consts from '../consts';
import { getConfig, setConfig } from '../configuracao/configLocal';
import html2canvas from 'html2canvas';
import {
  getList,
  update,
  initPlano,
  getListInterval,
  updateSerial,
  updatePlano,
  getControllerStep,
  getGradePlanos,
} from './intervaloActions';
import { generateReport } from './../relatorio/programacoes_plano/generateReport';
import Select from '../common/form/selectSemGrid';
import { toastr } from 'react-redux-toastr';
import ReactTableGT2A from '../common/grid/gridReactTable';
import Button from '../common/form/button';
import ButtonTooltip from '../common/form/buttonTooltip';
import traffic from '../image/traffic.png';
import trafficBranco from '../image/traffic_branco.png';
import trafficRed from '../image/traffic_red.png';
import trafficGreen from '../image/traffic_green.png';
import trafficYellow from '../image/traffic_yellow.png';
import If from '../common/operator/if';
import { Modal, Row } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import swal from 'sweetalert2';
import SelectPlanoSelect from '../common/selectdb/selectPlanoSelect';
import SelectConfAnel from '../common/selectdb/selectConfAnel.jsx';
import Grid from '../common/layout/grid';
import PermissaoUsuario from '../auth/permissao';
import { validaPermissaoDisabled, validaPermissaoReadOnly } from '../auth/permissaoActions';
import {
  sendForced,
  sendForcedSemSalvar,
  sendForcedComSalvar,
  sendCancelForced,
  getPlanosAgendados,
} from '../plano_forcado/planoForcadoAction';
import TooltipWrapper from '../common/form/TooltipWrapper'; // Importa o novo componente
import axiosInstance from '../main/axios';
import '../common/template/custom.css';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
const IntervaloValidacao = require('./intervaloValidacao');
const InputValidacao = require('../common/form/inputValidacao.js');
class IntervaloPlanoList extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.renderEditable = this.renderEditable.bind(this);
    this.iniciaSimulacao = this.iniciaSimulacao.bind(this);
    this.formatarTitulo = this.formatarTitulo.bind(this);
    this.salvaIntervalo = this.salvaIntervalo.bind(this);
    this.lerPlanoControlador = this.lerPlanoControlador.bind(this);
    this.lerPlanoDB = this.lerPlanoDB.bind(this);
    this.salvaIntervaloSerial = this.salvaIntervaloSerial.bind(this);
    this.salvaIntervaloDB = this.salvaIntervaloDB.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleGetList = this.handleGetList.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.cicloMaximoOnBlur = this.cicloMaximoOnBlur.bind(this);
    this.copiarPlano = this.copiarPlano.bind(this);
    this.iniciaTempoReal = this.iniciaTempoReal.bind(this);
    this.executaTempoReal = this.executaTempoReal.bind(this);
    this.simulacao = this.simulacao.bind(this);
    this.ativarPlanoIntermitente = this.ativarPlanoIntermitente.bind(this);
    this.desativarPlanoIntermitente = this.desativarPlanoIntermitente.bind(this);
    this.modoPiscante = this.modoPiscante.bind(this);
    this.adicionaIntervalo = this.adicionaIntervalo.bind(this);
    this.removeIntervalo = this.removeIntervalo.bind(this);
    this.exibeImagem = this.exibeImagem.bind(this);
    this.onChangeAnel = this.onChangeAnel.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.tentativaFecharPlano = this.tentativaFecharPlano.bind(this);
    this.dismissEnvioControladorErro = this.dismissEnvioControladorErro.bind(this);

    this.nIntervId = 0;
    this.tempoRealId = 0;
    this.intermitenteId = 0;
    this.segundos = 0.0;
    this.tempoIntervalo = [];
    this.coresFase = [];
    this.pngFase = [];
    this.countTempo = 0;
    this.corIdAtual = 0;
    this.segundoAtual = 0;
    this.intervaloAnterior = 0;
    this.intervaloTempoReal = 0;
    this.numeroFaseAtual = 0;
    this.totalFases = 0;
    // Timers auxiliares para o modo intermitente
    this.intermitenteHeartbeatId = 0; // verifica de tempos em tempos se saiu do intermitente
    this.intermitenteNextTimeoutId = 0; // agenda checagem próximo evento programado

    this.state = {
      emModoDeEspera: false,
      intervaloAnterior: 0,
      cronometroTpN: 0,
      cronometroExtensao: 0,
      show: false,
      loop: 0,
      tempoRealAtivo: false,
      disabledbtn: false,
      disabledbtnSimula: false,
      disabledbtnTempoReal: false,
      disabledbtnplano: false,
      tempoRealPlano: 0,
      modOperacaoDesc: [
        'Isolado/Normal',
        'Isolado/Atuado',
        'Isolado Atuado com Sequência Lógica',
        'Sincronizado/Normal',
        'Sincronizado/Atuado',
        'Sincronizado Atuado com Sequência Lógica',
        'Adaptativo Local',
        'Adaptativo Sincronizado',
      ],
      chageChave: false,
      modo: '',
      tipoCiclo: '',
      defasagem: 0,
      tempoDecorrido: 0,
      dataPlano: null,
      dataAnel: null,
      dataNumControlador: null,
      dataControlador: null,
      dataGrupo: null,
      list: [],
      tableUpdateKey: Date.now(),
      titulo: '',
      showLegendModal: false,
      controladorSalvo: false,
      sistemaSalvo: false,
      planoAnteriorLabel: '',
      planoAtualLabel: '',
      planoProximoLabel: '',
      planoApagado: false,
      faseDescricoes: {},
      /** Após envio bem-sucedido ao controlador: obrigar conferência com "Ler do Controlador". */
      verificacaoControladorPendente: false,
      /** Mensagem persistente quando o envio falha (pacotes/intervalos/canal). */
      envioControladorErro: null,
    };
  }

  // Função auxiliar para formatar o título do plano
  formatarTitulo(numControlador, anel, plano) {
    const planoNum = parseInt(plano);
    // Para planos entre 49 e 63, mostrar apenas "Intermitente" sem o número
    if (planoNum >= 49 && planoNum <= 63) {
      return `Controlador ${numControlador} - Anel ${anel} - Intermitente`;
    }
    // Para outros planos, mostrar normalmente
    return `Controlador ${numControlador} - Anel ${anel} - Plano ${plano}`;
  }

  componentDidMount() {
    this._isMounted = true;
    this.setState(
      {
        dataPlano: this.props['data-plano'],
        dataAnel: this.props['data-anel'],
        dataControlador: this.props['data-controlador'],
        dataNumControlador: this.props['data-num-controlador'],
        dataGrupo: this.props['data-grupo'],
        titulo: this.formatarTitulo(
          this.props['data-num-controlador'],
          this.props['data-anel'],
          this.props['data-plano'],
        ),
      },
      this.carregarDados,
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.nIntervId) clearInterval(this.nIntervId);
    if (this.tempoRealId) clearInterval(this.tempoRealId);
    if (this.intermitenteId) clearInterval(this.intermitenteId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps['data-plano'] !== this.props['data-plano'] ||
      prevProps['data-anel'] !== this.props['data-anel'] ||
      prevProps['data-controlador'] !== this.props['data-controlador']
    ) {
      this.setState(
        {
          dataPlano: this.props['data-plano'],
          dataAnel: this.props['data-anel'],
          dataControlador: this.props['data-controlador'],
          titulo: this.formatarTitulo(this.state.dataNumControlador, this.props['data-anel'], this.props['data-plano']),
        },
        this.carregarDados,
      );
    }
  }

  async carregarDados() {
    if (!this._isMounted) return;
    try {
      const result = await this.props.getList(this.state.dataControlador, this.state.dataPlano, this.state.dataAnel);
      if (this._isMounted) {
        let data = JSON.parse(JSON.stringify(result.payload.data));
        const modoOperacaoId = parseInt(data[0].modo_operacao_id) || 0;

        // Verificar se há plano forçado ativo (intermitente) para este controlador
        try {
          const planosAgendadosResult = await this.props.getPlanosAgendados(this.state.dataControlador);
          const planosAgendados =
            (planosAgendadosResult && planosAgendadosResult.payload && planosAgendadosResult.payload.data) || [];
          const temIntermitenteAtivo = planosAgendados.some(p => p.plano_id === 63);

          if (this._isMounted) {
            this.setState({ disabledbtnplano: temIntermitenteAtivo });
            setConfig('disabledbtnplano', temIntermitenteAtivo);
          }
        } catch (error) {
          console.error('Erro ao verificar planos agendados:', error);
        }

        // Injeta a linha TH (Tempo de Headway) se for modo adaptativo (6 ou 7) e ela não existir
        if ([6, 7].includes(modoOperacaoId)) {
          const hasTH = data.some(row => row.descricao === 'TH');
          if (!hasTH) {
            const templateRow = data.find(row => row.descricao === 'ND'); // Usa ND como molde
            if (templateRow) {
              const thRow = { ...templateRow, descricao: 'TH' };
              Object.keys(thRow).forEach(key => {
                if (key.startsWith('col_')) thRow[key] = 0;
              });
              data.push(thRow);
            }
          }
        }

        const anelId = parseInt(this.state.dataAnel) || 0;

        // Filtra as linhas com base no modoOperacaoId
        let linhasExibidas = data.filter(row => {
          const descricao = row.descricao;

          // Linhas de fases e Mod devem aparecer em todos os modos
          if (descricao === 'Mod' || descricao.startsWith('F')) {
            return true;
          }

          if ([0, 3].includes(modoOperacaoId)) {
            // Modos Isolado/Normal e Sincronizado/Normal: Exclui ND, TE, TME
            return !['ND', 'TE', 'TME'].includes(descricao);
          } else if ([1, 4].includes(modoOperacaoId)) {
            // Isolado/Atuado, Sincronizado/Atuado: TpN, TpM, ND, TE, TME
            return ['TpN', 'TpM', 'ND', 'TE', 'TME'].includes(descricao);
          } else if ([2, 5].includes(modoOperacaoId)) {
            // Modos atuados com Sequência Lógica: TpN, TpM, ND, SL, TE, TME
            return ['TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'].includes(descricao);
          } else if ([6, 7].includes(modoOperacaoId)) {
            // Modos Adaptativo: TpN, TpM, ND, TH, TE, TME
            return ['TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'].includes(descricao);
          }
          return false;
        });

        // Encontrar todas as fases presentes nos dados
        const fases = linhasExibidas
          .filter(row => row.descricao.startsWith('F'))
          .map(row => row.descricao)
          .sort((a, b) => {
            // Extrair os números das strings de fase (F9, F10, etc.)
            const numA = parseInt(a.substring(1));
            const numB = parseInt(b.substring(1));
            // Comparar numericamente em vez de alfabeticamente
            return numA - numB;
          });

        // Reordena as linhas para garantir a sequência correta
        if ([1, 4].includes(modoOperacaoId)) {
          // Sequência para modos 1, 4: Mod, F1-Fn, TpN, TpM, ND, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else if ([2, 5].includes(modoOperacaoId)) {
          // Sequência para modos 2, 5: Mod, F1-Fn, TpN, TpM, ND, SL, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else if ([6, 7].includes(modoOperacaoId)) {
          // Sequência para modos 6, 7: Mod, F1-Fn, TpN, TpM, ND, TH, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else {
          // Para os modos 0 e 3
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        }

        // Atualiza o estado com as linhas filtradas e reordenadas
        this.handleDataChange(linhasExibidas, {
          tableUpdateKey: Date.now(),
          verificacaoControladorPendente: false,
          envioControladorErro: null,
        });
        this.atualizarCamposFormulario(linhasExibidas);
        this._carregarFaseDescricoes(data);
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      if (this._isMounted) toastr.error('Erro', 'Falha ao carregar dados.');
    }
  }

  async _carregarFaseDescricoes(data) {
    if (!data || !data[0]) return;
    try {
      const controladorId = data[0].controlador_id || this.state.dataControlador;
      if (!controladorId) return;
      const faseRows = data.filter(r => r.descricao && r.descricao.startsWith('F'));
      const faseNums = faseRows.map(r => parseInt(r.descricao.substring(1))).filter(Boolean);
      const faseIni = data[0].fase_ini || (faseNums.length ? Math.min(...faseNums) : 1);
      const faseFin = data[0].fase_fin || (faseNums.length ? Math.max(...faseNums) : 16);
      const resp = await axiosInstance.get(`/fases/${controladorId}/${faseIni}/${faseFin}`);
      if (resp && resp.data && this._isMounted) {
        const map = {};
        resp.data.forEach(f => {
          if (f.id && f.descricao) map[f.id] = f.descricao;
        });
        this.setState({ faseDescricoes: map });
      }
    } catch (e) {
      // descrições de fase são opcionais — falha silenciosa
    }
  }

  ativarPlanoIntermitente() {
    swal({
      title: 'Ativar o "Plano Intermitente"?',
      html: '<h5>Essa ação irá ativar o plano 63.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value && this._isMounted) {
        this.setState({ show: true });
        const list = this.state.list.length > 0 ? this.state.list : this.props.list || [];
        let contId = list[0].controlador_id;
        let value = {
          grupoFisicoId: 0,
          contId: contId,
          pf_anel: 5,
          plano_id: 63,
          horario_inicial: '00:00:00',
          horario_final: '23:59:59',
        };
        this.props
          .sendForcedComSalvar(value)
          .then(() => {
            if (this._isMounted) {
              this.setState({ show: false, disabledbtnplano: true });
              setConfig('disabledbtnplano', true);
              toastr.success('Sucesso', 'Plano intermitente ativado com sucesso.');
            }
          })
          .catch(e => {
            if (this._isMounted) {
              this.setState({ show: false, disabledbtnplano: false });
              setConfig('disabledbtnplano', false);
              e.response.data.errors.forEach(error => toastr.error('Erro', error));
            }
          });
      }
    });
  }

  desativarPlanoIntermitente() {
    swal({
      title: 'Desativar o "Plano Intermitente"?',
      html: '<h5>Essa ação irá desativar o plano 63.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value && this._isMounted) {
        this.setState({ show: true });
        const list = this.state.list.length > 0 ? this.state.list : this.props.list || [];
        let contId = list[0].controlador_id;
        let value = {
          grupoFisicoId: 0,
          contId: contId,
          pf_anel: 5,
          plano_id: 63,
          horario_inicial: '00:00:00',
          horario_final: '23:59:59',
        };
        this.props
          .sendCancelForced(value)
          .then(() => {
            if (this._isMounted) {
              this.setState({ show: false, disabledbtnplano: false });
              setConfig('disabledbtnplano', false);
              toastr.success('Sucesso', 'Plano intermitente desativado com sucesso.');
            }
          })
          .catch(e => {
            if (this._isMounted) {
              this.setState({ show: false, disabledbtnplano: false });
              setConfig('disabledbtnplano', false);
              e.response.data.errors.forEach(error => toastr.error('Erro', error));
            }
          });
      }
    });
  }

  forceTableUpdate() {
    if (this._isMounted) {
      this.setState({ tableUpdateKey: Date.now() });
    }
  }

  handleClose() {
    if (this._isMounted) this.setState({ show: false });
  }

  dismissEnvioControladorErro() {
    if (this._isMounted) this.setState({ envioControladorErro: null });
  }

  async tentativaFecharPlano() {
    if (!this._isMounted) return;
    if (this.state.verificacaoControladorPendente) {
      const result = await swal.fire({
        title: 'Conferência obrigatória pendente',
        html:
          '<p style="text-align:left;margin-bottom:10px">O plano foi enviado ao controlador, mas você ainda não executou <strong>Ler do Controlador</strong> nesta sessão.</p>' +
          '<p style="text-align:left;margin:0">Sem essa leitura não há garantia de que o equipamento gravou exatamente o que aparece na tela — falhas esporádicas de comunicação já causaram intervalos incorretos em campo.</p>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#64748b',
        cancelButtonColor: '#0ea5e9',
        confirmButtonText: 'Fechar mesmo assim',
        cancelButtonText: 'Voltar e ler do controlador',
        allowOutsideClick: false,
      });
      if (!result.value) return;
    }
    if (this.props.initPlano) this.props.initPlano();
  }

  handleShow() {
    if (this._isMounted) this.setState({ show: true });
  }

  async handleGetList() {
    if (!this._isMounted) return;
    try {
      const result = await this.props.getList(this.state.dataControlador, this.state.dataPlano, this.state.dataAnel);
      if (this._isMounted) {
        let newData = JSON.parse(JSON.stringify(result.payload.data));

        // Injeta a linha TH (Tempo de Headway) se for modo adaptativo (6 ou 7) e ela não existir
        const modoOperacaoId = parseInt(newData[0].modo_operacao_id) || 0;
        if ([6, 7].includes(modoOperacaoId)) {
          const hasTH = newData.some(row => row.descricao === 'TH');
          if (!hasTH) {
            const templateRow = newData.find(row => row.descricao === 'ND');
            if (templateRow) {
              const thRow = { ...templateRow, descricao: 'TH' };
              Object.keys(thRow).forEach(key => {
                if (key.startsWith('col_')) thRow[key] = 0;
              });
              newData.push(thRow);
            }
          }
        }

        // Filtrar as linhas com base no modo de operação
        let linhasExibidas = newData.filter(row => {
          const descricao = row.descricao;

          // Linhas de fases e Mod devem aparecer em todos os modos
          if (descricao === 'Mod' || descricao.startsWith('F')) {
            return true;
          }

          if ([0, 3].includes(modoOperacaoId)) {
            // Modos Isolado/Normal e Sincronizado/Normal: Exclui ND, TE, TME
            return !['ND', 'TE', 'TME'].includes(descricao);
          } else if ([1, 4].includes(modoOperacaoId)) {
            // Isolado/Atuado, Sincronizado/Atuado: TpN, TpM, ND, TE, TME
            return ['TpN', 'TpM', 'ND', 'TE', 'TME'].includes(descricao);
          } else if ([2, 5].includes(modoOperacaoId)) {
            // Modos atuados com Sequência Lógica: TpN, TpM, ND, SL, TE, TME
            return ['TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'].includes(descricao);
          } else if ([6, 7].includes(modoOperacaoId)) {
            // Modos Adaptativo: TpN, TpM, ND, TH, TE, TME
            return ['TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'].includes(descricao);
          }
          return false;
        });

        // Encontrar todas as fases presentes nos dados
        const fases = linhasExibidas
          .filter(row => row.descricao.startsWith('F'))
          .map(row => row.descricao)
          .sort((a, b) => {
            // Extrair os números das strings de fase (F9, F10, etc.)
            const numA = parseInt(a.substring(1));
            const numB = parseInt(b.substring(1));
            // Comparar numericamente em vez de alfabeticamente
            return numA - numB;
          });

        // Reordena as linhas para garantir a sequência correta
        if ([1, 4].includes(modoOperacaoId)) {
          // Sequência para modos 1, 4: Mod, F1-Fn, TpN, TpM, ND, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else if ([2, 5].includes(modoOperacaoId)) {
          // Sequência para modos 2, 5: Mod, F1-Fn, TpN, TpM, ND, SL, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else if ([6, 7].includes(modoOperacaoId)) {
          // Sequência para modos 6, 7: Mod, F1-Fn, TpN, TpM, ND, TH, TE, TME
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        } else {
          // Para os modos 0 e 3
          const desiredOrder = ['Mod', ...fases, 'TpN', 'TpM'];
          linhasExibidas.sort((a, b) => {
            const indexA = desiredOrder.indexOf(a.descricao);
            const indexB = desiredOrder.indexOf(b.descricao);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
          });
        }

        this.handleDataChange(linhasExibidas, { tableUpdateKey: Date.now() });
        this._carregarFaseDescricoes(newData);
      }
    } catch (error) {
      console.error('Erro em handleGetList:', error);
    }
  }

  lerPlanoDB() {
    if (!this._isMounted) return;
    this.setState({ show: true });
    this.props
      .getList(this.state.dataControlador, this.state.dataPlano, this.state.dataAnel)
      .then(result => {
        if (this._isMounted) {
          this.setState({ show: false });
          let newData = JSON.parse(JSON.stringify(result.payload.data));
          if (newData && newData.length > 0) {
            // Injeta a linha TH se necessário
            const modoOperacaoId = parseInt(newData[0].modo_operacao_id) || 0;
            if ([6, 7].includes(modoOperacaoId)) {
              const hasTH = newData.some(row => row.descricao === 'TH');
              if (!hasTH) {
                const templateRow = newData.find(row => row.descricao === 'ND');
                if (templateRow) {
                  const thRow = { ...templateRow, descricao: 'TH' };
                  Object.keys(thRow).forEach(key => {
                    if (key.startsWith('col_')) thRow[key] = 0;
                  });
                  newData.push(thRow);
                }
              }
            }

            // Filtrar e ordenar usando a função centralizada (respeita fase_ini/fase_fin do anel)
            const { linhasExibidas: linhasFiltradas } = this._filtrarEOrdenarLinhas(newData);

            // Atualizar o estado com os dados processados
            this.handleDataChange(linhasFiltradas, { tableUpdateKey: Date.now() });
            this.atualizarCamposFormulario(linhasFiltradas);
            toastr.success('Sucesso', 'Dados lidos do sistema e atualizados em tela.');
          } else {
            toastr.warning('Atenção', 'Sistema não retornou dados válidos para este plano/anel.');
          }
        }
      })
      .catch(e => {
        if (this._isMounted) {
          this.setState({ show: false });
          toastr.error('Erro ao ler do banco', e.message);
        }
      });
  }

  lerPlanoControlador() {
    if (!this._isMounted) return;
    this.setState({ show: true });
    this.props
      .getListInterval(this.state.dataPlano, this.state.dataAnel, this.state.dataNumControlador, this.state.dataGrupo)
      .then(result => {
        if (this._isMounted) {
          this.setState({ show: false });
          if (result.error) {
            toastr.error('Erro', result.payload.response.data.errors[0]);
            this.handleGetList(); // Reads from DB on error
          } else {
            let newData = JSON.parse(JSON.stringify(result.payload.data));
            if (newData && newData.length > 0) {
              // Injeta a linha TH se necessário
              const modoOperacaoId = parseInt(newData[0].modo_operacao_id) || 0;
              if ([6, 7].includes(modoOperacaoId)) {
                const hasTH = newData.some(row => row.descricao === 'TH');
                if (!hasTH) {
                  const templateRow = newData.find(row => row.descricao === 'ND');
                  if (templateRow) {
                    const thRow = { ...templateRow, descricao: 'TH' };
                    Object.keys(thRow).forEach(key => {
                      if (key.startsWith('col_')) thRow[key] = 0;
                    });
                    newData.push(thRow);
                  }
                }
              }

              // Filtrar e ordenar usando a função centralizada (respeita fase_ini/fase_fin do anel)
              const { linhasExibidas: linhasFiltradas } = this._filtrarEOrdenarLinhas(newData);

              // Atualizar o estado com os dados processados
              this.handleDataChange(linhasFiltradas, {
                tableUpdateKey: Date.now(),
                verificacaoControladorPendente: false,
                envioControladorErro: null,
              });
              this.atualizarCamposFormulario(linhasFiltradas);
              toastr.success('Conferência ok', 'Dados lidos do controlador e atualizados na tela.');
            } else {
              toastr.warning('Atenção', 'Controlador não retornou dados válidos para este plano/anel.');
              this.handleGetList(); // Fallback para ler do DB
            }
          }
        }
      })
      .catch(e => {
        if (this._isMounted) {
          this.setState({ show: false });
          toastr.error('Erro', 'Sem conexão. Verifique se a central está conectada.');
          this.handleGetList();
        }
      });
  }

  async salvaIntervalo() {
    this.salvaIntervaloSerial();
  }

  async salvaIntervaloSerial() {
    if (!this._isMounted) return;

    const list = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    if (!IntervaloValidacao.validaRegrasIntervalo(list)) return;

    const confirma = await swal
      .fire({
        title: 'Enviar as configurações desse plano para o "Controlador"?',
        html: '<h5>Essa ação vai substituir as configurações existentes na central.</h5>',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: 'primary',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      })
      .then(result => result.value);

    if (!confirma || !this._isMounted) return;

    this.setState({ show: true, envioControladorErro: null });

    // Lógica unificada para todos os modos. O back-end em /intervalos/serial
    // é responsável por tratar os diferentes modos de operação, incluindo o adaptativo.
    try {
      const resp = await this.props.updateSerial(list, this.state.dataControlador, this.state.dataNumControlador);
      const body = resp && resp.data ? resp.data : null;

      if (!body || body.success !== true) {
        if (this._isMounted) {
          const detalhe = body && body.error ? String(body.error).trim() : '';
          const envioControladorErro =
            'Falha ao enviar ao controlador ou a central não confirmou o envio completo.' +
            (detalhe ? ` ${detalhe}` : '') +
            ' Um ou mais intervalos podem não ter sido gravados — o equipamento pode ficar com plano incompleto. Não confie nesta operação: refaça o envio após corrigir a comunicação e use "Ler do Controlador" para conferir.';
          this.setState({
            show: false,
            envioControladorErro,
            verificacaoControladorPendente: false,
          });
          toastr.error(
            'Envio incompleto ou negado',
            detalhe || 'Verifique a comunicação com a central e tente novamente.',
          );
        }
        return;
      }

      const canvas = await html2canvas(this.componentRef.current);
      const image = canvas.toDataURL('png');
      list[0]['imageLog'] = {
        numCont: this.state.dataNumControlador,
        grupoId: this.state.dataGrupo,
        anelId: this.state.dataAnel,
        image,
      };
      for (let key in list) {
        await this.props.update(list[key]);
      }
      await this.props.updatePlano(list[0]);
      if (this._isMounted) {
        this.setState({
          show: false,
          controladorSalvo: true,
          sistemaSalvo: true,
          verificacaoControladorPendente: true,
          envioControladorErro: null,
        });
        toastr.success(
          'Sucesso',
          'Plano enviado à central. Agora use "Ler do Controlador" para confirmar o equipamento.',
        );
      }
    } catch (e) {
      if (this._isMounted) {
        let errs = '';
        if (e.response && e.response.data && e.response.data.errors) {
          errs = e.response.data.errors.map(er => String(er)).join(' ');
          toastr.error('Envio falhou', errs.length > 220 ? `${errs.slice(0, 217)}…` : errs);
        } else {
          errs = e.message || 'Erro desconhecido ao processar a requisição.';
          toastr.error('Erro', errs);
        }
        const envioControladorErro =
          'A requisição falhou durante o envio ao controlador. Alguns intervalos podem não ter sido gravados na central.' +
          (errs ? ` Detalhe: ${errs}` : '') +
          ' Verifique a rede e use "Ler do Controlador" antes de confiar no estado do equipamento.';
        this.setState({
          show: false,
          envioControladorErro,
          verificacaoControladorPendente: false,
        });
      }
    }
  }

  async salvaIntervaloDB() {
    if (!this._isMounted) return;
    const list = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    if (!IntervaloValidacao.validaRegrasIntervalo(list)) return;

    this.setState({ show: true });
    try {
      const canvas = await html2canvas(this.componentRef.current);
      const image = canvas.toDataURL('png');
      list[0]['imageLog'] = {
        numCont: this.state.dataNumControlador,
        grupoId: this.state.dataGrupo,
        anelId: this.state.dataAnel,
        image,
      };
      for (let key in list) {
        await this.props.update(list[key]);
      }
      // this.props.initPlano(); // REMOVIDO: Mantém o usuário na tela
      if (this._isMounted) {
        this.setState({ show: false, sistemaSalvo: true }); // ATUALIZADO: Define o estado de salvo
        toastr.success('Sucesso', 'Plano salvo no banco de dados.');
      }
    } catch (e) {
      if (this._isMounted) {
        this.setState({ show: false });
        toastr.error('Erro', 'Erro ao salvar os dados no banco de dados');
      }
    }
  }

  renderEditable(cellInfo) {
    const list = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    let valorAtual = list[cellInfo.index][cellInfo.column.id];
    let modoDesabled = false; // Alterado para booleano para facilitar a lógica
    let classOptionHidden = '';
    let classOptionNDHidden = '';
    let SLEditable = true;
    let col_id = 0;
    let classModValid = '';
    let classNDValid = '';
    let classNDPressionado = '';

    const modoOperacaoId = parseInt(list[0].modo_operacao_id) || 0;

    if (cellInfo.original.descricao === 'Mod') {
      // Oculta opções Atuado/Sec.Alternativo/Atuado Variável para modos 0 e 3 (Normal e Sincronizado Normal)
      if ([0, 3].indexOf(parseInt(list[0].modo_operacao_id)) >= 0) {
        classOptionHidden = 'option_hidden';
      }
      col_id = cellInfo.column.id.split('_');
      if (
        [1, 3].indexOf(parseInt(cellInfo.original[`col_${parseInt(col_id[1]) - 1}`])) >= 0 ||
        [1, 3].indexOf(parseInt(cellInfo.original[`col_${parseInt(col_id[1]) + 1}`])) >= 0
      ) {
        modoDesabled = true;
      }
      if (parseInt(col_id[1]) === parseInt(list[0].numero_intervalo)) {
        modoDesabled = true;
      }
      if (
        !list[0].is_plano_apagado &&
        [1, 3, 5, 6].indexOf(parseInt(cellInfo.original[`col_${parseInt(col_id[1])}`])) >= 0
      ) {
        for (const key in list) {
          if (list[key].descricao === 'TpM' && parseFloat(list[key][cellInfo.column.id]) < 3) {
            list[key][cellInfo.column.id] = 3;
          }
        }
      }

      // COMENTEI PQ ACHO QUE É DESNECESSARIO, ACOMPANHAR SE GERA ALGUM PROBLEMA
      // if ([5, 6].indexOf(parseInt(cellInfo.original[`col_${parseInt(col_id[1])}`])) >= 0) {
      //   for (const key in list) {
      //     if (list[key].descricao === 'TME') {
      //       window.$(`.class_avm_${cellInfo.column.id}`).css('border', 'solid #38B0DE 2px');
      //       if (parseFloat(list[key][cellInfo.column.id]) < 6) list[key][cellInfo.column.id] = 6;
      //     } else if (list[key].descricao === 'TE') {
      //       window.$(`.class_av_${cellInfo.column.id}`).css('border', 'solid #38B0DE 2px');
      //       if (parseFloat(list[key][cellInfo.column.id]) < 3) list[key][cellInfo.column.id] = 3;
      //     }
      //   }
      // } else {
      //   for (const key in list) {
      //     if (['TME', 'TE'].indexOf(list[key].descricao) >= 0) {
      //       window.$(`.class_avm_${cellInfo.column.id}`).css('border', 'solid #cccccc 1px');
      //       window.$(`.class_av_${cellInfo.column.id}`).css('border', 'solid #cccccc 1px');
      //     }
      //   }
      // }
      let classeMod = ['sel-nenhum', 'mod-p', 'mod-s', 'mod-a', 'mod-sa', 'mod-pp', 'mod-aa', 'mod-pi', 'mod-ai'];
      let hiddenMod = ['', '', '', '', '', '', '', '', '', '', ''];
      if (cellInfo.column.id === 'col_1')
        hiddenMod = ['hidden', '', 'hidden', 'hidden', 'hidden', '', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden'];
      classModValid = `class_mod_${cellInfo.column.id}`;

      // --- NOVA LÓGICA DE VALIDAÇÃO PARA MODO ADAPTATIVO ---
      let pDisabled = false;
      let sDisabled = false;
      let aDisabled = false;

      const { config } = this.props;
      const usa_adaptativo = config && config.usa_adaptativo;

      if (usa_adaptativo && [6, 7].includes(modoOperacaoId)) {
        // Ignora a lógica de desabilitar legada para os modos adaptativos
        modoDesabled = false;

        const currentColIndex = parseInt(cellInfo.column.id.split('_')[1]);
        const prevColMode = currentColIndex > 1 ? parseInt(list[0][`col_${currentColIndex - 1}`]) : null;

        const Principais = [1, 5, 7];
        const Atuados = [3, 6, 8];
        const Secundarios = [2, 4];
        const PrimAtuados = [...Principais, ...Atuados];

        if (currentColIndex === 1) {
          // O primeiro intervalo DEVE ser Principal Adaptativo. Desabilita os outros tipos.
          aDisabled = true;
          sDisabled = true;
        } else if (prevColMode) {
          // Lógica para os intervalos seguintes, baseada no anterior
          if (PrimAtuados.includes(prevColMode)) {
            // Se o anterior foi Principal ou Atuado, o atual DEVE ser Secundário.
            pDisabled = true;
            aDisabled = true;
            sDisabled = false; // Garante que Secundário esteja habilitado
          } else if (Secundarios.includes(prevColMode)) {
            // Se o anterior foi Secundário, o atual pode ser outro Secundário OU um Principal/Atuado.
            // Portanto, não desabilitamos nenhuma categoria de opção aqui.
            pDisabled = false;
            aDisabled = false;
            sDisabled = false;
          } else {
            // Caso inválido (ex: 0 - apagado), desabilita tudo por segurança.
            pDisabled = true;
            aDisabled = true;
            sDisabled = true;
          }
        }
      }
      // --- FIM DA NOVA LÓGICA ---

      return (
        <Select
          id={`select_modo_${cellInfo.column.id}`}
          className={`select-gridPlano select-gridPlano-mod class_borda_${cellInfo.column.id} ${
            classeMod[valorAtual]
          } ${classModValid}`}
          contentEditable
          suppressContentEditableWarning
          onChange={event => {
            if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl') === '' && this._isMounted) {
              const data = [...list];
              if (data[cellInfo.index][cellInfo.column.id] !== event.target.value) {
                this.setState({ chageChave: true });

                const eventValue = parseInt(event.target.value);

                if (eventValue === 98) {
                  this.adicionaIntervalo(cellInfo.column.id);
                  return;
                }
                if (eventValue === 99) {
                  this.removeIntervalo(cellInfo.column.id);
                  return;
                }

                const novoMod = eventValue;
                data[cellInfo.index][cellInfo.column.id] = novoMod;

                // Se o novo modo não permite edição de ND, zera o valor de ND para essa coluna.
                if (![3, 5, 6, 7, 8].includes(novoMod)) {
                  const ndRowIndex = data.findIndex(row => row.descricao === 'ND');
                  if (ndRowIndex > -1) {
                    data[ndRowIndex][cellInfo.column.id] = 0;
                  }
                }

                this.handleDataChange(data);

                if ([1, 2].indexOf(novoMod) >= 0) {
                  window.$(`.class_mod_${cellInfo.column.id}`).css('border', 'solid #cccccc 2px');
                }

                const col_id_split = cellInfo.column.id.split('_');
                const col_id_num = parseInt(col_id_split[1]);

                if ([1, 3, 5, 6, 7, 8].indexOf(novoMod) >= 0) {
                  window.$(`#select_modo_col_${col_id_num + 1} option`).each(function() {
                    window.$(this).removeAttr('disabled');
                    if ([1, 3, 5, 6, 7, 8].indexOf(parseInt(window.$(this).val())) >= 0) {
                      window.$(this).attr('disabled', 'disabled');
                    }
                  });
                  window.$(`#select_modo_col_${col_id_num - 1} option`).each(function() {
                    window.$(this).removeAttr('disabled');
                    if ([1, 3, 5, 6, 7, 8].indexOf(parseInt(window.$(this).val())) >= 0) {
                      window.$(this).attr('disabled', 'disabled');
                    }
                  });
                } else {
                  window.$(`#select_modo_col_${col_id_num + 1} option`).each(function() {
                    if ([1, 3].indexOf(parseInt(window.$(this).val())) < 0) {
                      window.$(this).removeAttr('disabled');
                    }
                  });
                  window.$(`#select_modo_col_${col_id_num - 1} option`).each(function() {
                    if ([1, 3].indexOf(parseInt(window.$(this).val())) < 0) {
                      window.$(this).removeAttr('disabled');
                    }
                  });
                }
              }
            }
          }}
          value={valorAtual}
          disabled={validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_mod_fase')}
        >
          <option value="0" hidden={hiddenMod[0]} className="sel-nenhum" />
          <option value="1" hidden={hiddenMod[1]} className="mod-p" disabled={modoDesabled || pDisabled}>
            &nbsp;P&nbsp;&nbsp;=&nbsp;&nbsp;Principal
          </option>
          <option value="2" hidden={hiddenMod[2]} className="mod-s" disabled={sDisabled}>
            &nbsp;S&nbsp;&nbsp;=&nbsp;&nbsp;Secundário
          </option>
          <option
            value="3"
            hidden={hiddenMod[3]}
            className={`mod-a ${classOptionHidden}`}
            disabled={modoDesabled || aDisabled}
          >
            &nbsp;A&nbsp;&nbsp;=&nbsp;&nbsp;Atuado
          </option>
          <option value="4" hidden={hiddenMod[4]} className={`mod-sa ${classOptionHidden}`} disabled={sDisabled}>
            SA&nbsp;&nbsp;=&nbsp;&nbsp;Sec. Alternativo
          </option>
          <option
            value="5"
            hidden={hiddenMod[5] || !([6, 7].includes(modoOperacaoId) && usa_adaptativo)}
            className="mod-pp"
            disabled={modoDesabled || pDisabled}
            dangerouslySetInnerHTML={{
              __html:
                (modoOperacaoId === 6 || modoOperacaoId === 7) && usa_adaptativo
                  ? '&nbsp;p&nbsp;&nbsp;=&nbsp;&nbsp;Adaptativo Coletivo'
                  : ' &nbsp;p&nbsp;&nbsp;=&nbsp;&nbsp;Principal Variável',
            }}
          />
          <option
            value="6"
            hidden={hiddenMod[6]}
            className={`mod-aa ${classOptionHidden}`}
            disabled={modoDesabled || aDisabled}
            dangerouslySetInnerHTML={{
              __html:
                (modoOperacaoId === 6 || modoOperacaoId === 7) && usa_adaptativo
                  ? ' &nbsp;a&nbsp;&nbsp;=&nbsp;&nbsp;Atuado Adap. Coletivo'
                  : ' &nbsp;a&nbsp;&nbsp;=&nbsp;&nbsp;Atuado Variável',
            }}
          />
          <option
            value="7"
            hidden={!([6, 7].includes(modoOperacaoId) && usa_adaptativo)}
            className="mod-pi"
            disabled={modoDesabled || pDisabled}
            dangerouslySetInnerHTML={{
              __html: '&nbsp;I&nbsp;&nbsp;=&nbsp;&nbsp;Adaptativo Individual',
            }}
          />
          <option
            value="8"
            hidden={!([6, 7].includes(modoOperacaoId) && usa_adaptativo)}
            className="mod-ai"
            disabled={modoDesabled || aDisabled}
            dangerouslySetInnerHTML={{
              __html: '&nbsp;i&nbsp;&nbsp;=&nbsp;&nbsp;Atuado Adap. Individual',
            }}
          />
          <option value="98" hidden={hiddenMod[9]} className="sel-nenhum">
            (+) Adicionar Intervalo
          </option>
          <option value="99" hidden={hiddenMod[10]} className="sel-nenhum">
            (-) Remover Intervalo
          </option>
        </Select>
      );
    }

    if (['TpN', 'ND', 'TpM', 'SL', 'TE', 'TME', 'TH'].indexOf(cellInfo.original.descricao) >= 0) {
      if (cellInfo.original.descricao === 'ND') {
        const modColuna = parseInt(list[0][cellInfo.column.id]) || 0;
        const { config } = this.props;
        const usa_adaptativo = config && config.usa_adaptativo;

        // Modos Adaptativos (6, 7) - usam o select com combinações
        if (usa_adaptativo && [6, 7].includes(modoOperacaoId)) {
          const isEditable = [3, 5, 6, 7, 8].includes(modColuna); // Atuado Fixo, Principal Adaptativo e Atuado Adaptativo
          if (isEditable) {
            const getDetectorName = id => {
              if (id >= 1 && id <= 8) return `Botão ${id}`;
              if (id >= 9 && id <= 24) return `Laço ${id - 8}`;
              return '';
            };

            const options = [];
            options.push(<option key="0" value="0" dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />);

            for (let i = 1; i <= 24; i++) {
              const text = `${String(i).padStart(3, '0')}&nbsp;&nbsp;=&nbsp;&nbsp;${getDetectorName(i)}`;
              options.push(<option key={i} value={i} dangerouslySetInnerHTML={{ __html: text }} />);
            }

            for (let i = 1; i <= 23; i++) {
              const value = 100 + i;
              const text = `${String(value)}&nbsp;&nbsp;=&nbsp;&nbsp;${getDetectorName(i)} e ${getDetectorName(i + 1)}`;
              options.push(<option key={value} value={value} dangerouslySetInnerHTML={{ __html: text }} />);
            }

            for (let i = 1; i <= 22; i++) {
              const value = 200 + i;
              const text = `${String(value)}&nbsp;&nbsp;=&nbsp;&nbsp;${getDetectorName(i)}, ${getDetectorName(
                i + 1,
              )} e ${getDetectorName(i + 2)}`;
              options.push(<option key={value} value={value} dangerouslySetInnerHTML={{ __html: text }} />);
            }

            let classNDValid = `class_nd_${cellInfo.column.id}`;
            let classNDPressionado = `class_nd_${list[cellInfo.index][cellInfo.column.id]}`;

            return (
              <Select
                id={`select_numdetector_${cellInfo.column.id}`}
                className={`select-gridPlano select-gridPlano-nd class_borda_${
                  cellInfo.column.id
                } ${classNDValid} ${classNDPressionado}`}
                contentEditable
                suppressContentEditableWarning
                onChange={event => {
                  if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl') === '' && this._isMounted) {
                    const data = [...list];
                    if (data[cellInfo.index][cellInfo.column.id] !== event.target.value) {
                      this.setState({ chageChave: true });
                      data[cellInfo.index][cellInfo.column.id] = event.target.value;
                      this.handleDataChange(data);
                    }
                  }
                }}
                disabled={validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl')}
                value={list[cellInfo.index][cellInfo.column.id]}
              >
                {options}
              </Select>
            );
          } else {
            // CORREÇÃO: Exibir o valor existente de forma não editável em vez de apagar
            const currentValue = list[cellInfo.index][cellInfo.column.id];
            return (
              <div
                style={{
                  textAlign: 'center',
                  backgroundColor: '#eee',
                  color: '#777',
                  minHeight: '25px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {currentValue > 0 ? String(currentValue).padStart(3, '0') : '-'}
              </div>
            );
          }
        }
        // Modos Atuados (não-adaptativos: 1, 2, 4, 5) - usam select simples
        else if ([1, 2, 4, 5].includes(modoOperacaoId)) {
          const isEditable = [3, 5, 6].includes(modColuna); // Apenas Atuado, Principal Variavel, Atuado Variavel

          if (isEditable) {
            let classNDValid = `class_nd_${cellInfo.column.id}`;
            let classNDPressionado = `class_nd_${list[cellInfo.index][cellInfo.column.id]}`;
            return (
              <Select
                id={`select_numdetector_${cellInfo.column.id}`}
                className={`select-gridPlano select-gridPlano-nd class_borda_${
                  cellInfo.column.id
                } ${classNDValid} ${classNDPressionado}`}
                contentEditable
                suppressContentEditableWarning
                onChange={event => {
                  if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl') === '' && this._isMounted) {
                    const data = [...list];
                    if (data[cellInfo.index][cellInfo.column.id] !== event.target.value) {
                      this.setState({ chageChave: true });
                      if (parseInt(event.target.value) > 0) {
                        window.$(`.class_nd_${cellInfo.column.id}`).css('border', 'solid #cccccc 2px');
                      }
                      data[cellInfo.index][cellInfo.column.id] = event.target.value;
                      this.handleDataChange(data);
                    }
                  }
                }}
                disabled={validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl')}
                value={list[cellInfo.index][cellInfo.column.id]}
              >
                <option value="0"> </option>
                <option value="1">01&nbsp;&nbsp;=&nbsp;&nbsp;Botão 1</option>
                <option value="2">02&nbsp;&nbsp;=&nbsp;&nbsp;Botão 2</option>
                <option value="3">03&nbsp;&nbsp;=&nbsp;&nbsp;Botão 3</option>
                <option value="4">04&nbsp;&nbsp;=&nbsp;&nbsp;Botão 4</option>
                <option value="5">05&nbsp;&nbsp;=&nbsp;&nbsp;Botão 5</option>
                <option value="6">06&nbsp;&nbsp;=&nbsp;&nbsp;Botão 6</option>
                <option value="7">07&nbsp;&nbsp;=&nbsp;&nbsp;Botão 7</option>
                <option value="8">08&nbsp;&nbsp;=&nbsp;&nbsp;Botão 8</option>
                <option value="9">09&nbsp;&nbsp;=&nbsp;&nbsp;Laço 1</option>
                <option value="10">10&nbsp;&nbsp;=&nbsp;&nbsp;Laço 2</option>
                <option value="11">11&nbsp;&nbsp;=&nbsp;&nbsp;Laço 3</option>
                <option value="12">12&nbsp;&nbsp;=&nbsp;&nbsp;Laço 4</option>
                <option value="13">13&nbsp;&nbsp;=&nbsp;&nbsp;Laço 5</option>
                <option value="14">14&nbsp;&nbsp;=&nbsp;&nbsp;Laço 6</option>
                <option value="15">15&nbsp;&nbsp;=&nbsp;&nbsp;Laço 7</option>
                <option value="16">16&nbsp;&nbsp;=&nbsp;&nbsp;Laço 8</option>
                <option value="17">17&nbsp;&nbsp;=&nbsp;&nbsp;Laço 9</option>
                <option value="18">18&nbsp;&nbsp;=&nbsp;&nbsp;Laço 10</option>
                <option value="19">19&nbsp;&nbsp;=&nbsp;&nbsp;Laço 11</option>
                <option value="20">20&nbsp;&nbsp;=&nbsp;&nbsp;Laço 12</option>
                <option value="21">21&nbsp;&nbsp;=&nbsp;&nbsp;Laço 13</option>
                <option value="22">22&nbsp;&nbsp;=&nbsp;&nbsp;Laço 14</option>
                <option value="23">23&nbsp;&nbsp;=&nbsp;&nbsp;Laço 15</option>
                <option value="24">24&nbsp;&nbsp;=&nbsp;&nbsp;Laço 16</option>
              </Select>
            );
          }
        }

        // Para qualquer outra combinação, mostrar campo readonly
        return (
          <div
            style={{
              textAlign: 'center',
              backgroundColor: '#eee',
              color: '#777',
              minHeight: '25px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            -
          </div>
        );
      } else if (cellInfo.original.descricao === 'SL') {
        const modColuna = parseInt(list[0][cellInfo.column.id]) || 0;
        let isSLEditable = false;

        if ([2, 5].includes(modoOperacaoId)) {
          if ([1, 3, 6].includes(modColuna) && cellInfo.column.id !== 'col_1') {
            isSLEditable = true;
          }
        }

        if (validaPermissaoReadOnly('CadIntervaloPlano', 'intervalo_nd_sl')) {
          isSLEditable = false;
        }

        if (!isSLEditable) {
          if (list[cellInfo.index][cellInfo.column.id] !== 0) {
            list[cellInfo.index][cellInfo.column.id] = 0;
          }
          return (
            <div
              style={{
                textAlign: 'center',
                backgroundColor: '#eee',
                color: '#777',
                minHeight: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              -
            </div>
          );
        }

        // Usar classes próprias para SL para não conflitar com o destaque de ND
        let classSLValid = `class_sl_${cellInfo.column.id}`;
        let classSlPressionado = `class_sl_${list[cellInfo.index][cellInfo.column.id]}`;

        return (
          <Select
            id={`select_numdetector_${cellInfo.column.id}`}
            className={`select-gridPlano select-gridPlano-sl class_borda_${
              cellInfo.column.id
            } ${classSLValid} ${classSlPressionado}`}
            contentEditable
            suppressContentEditableWarning
            onChange={event => {
              if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_nd_sl') === '' && this._isMounted) {
                const data = [...list];
                if (data[cellInfo.index][cellInfo.column.id] !== event.target.value) {
                  this.setState({ chageChave: true });
                  if (parseInt(event.target.value) > 0) {
                    window.$(`.class_sl_${cellInfo.column.id}`).css('border', 'solid #cccccc 2px');
                  }
                  data[cellInfo.index][cellInfo.column.id] = event.target.value;
                  this.handleDataChange(data);
                }
              }
            }}
            value={list[cellInfo.index][cellInfo.column.id]}
          >
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
          </Select>
        );
      } else {
        const { descricao } = cellInfo.original;
        const modColuna = parseInt(list[0][cellInfo.column.id]) || 0;
        let isEditable = false;

        if (descricao === 'TpN') {
          isEditable = true;
        } else {
          if ([6, 7].includes(modoOperacaoId)) {
            if (descricao === 'TpM') isEditable = [1, 3, 5, 6, 7, 8].includes(modColuna);
            if (['TH', 'TE', 'TME'].includes(descricao)) isEditable = [5, 6, 7, 8].includes(modColuna);
          } else if ([2, 5].includes(modoOperacaoId)) {
            if (descricao === 'TpM') isEditable = [1, 3, 5, 6].includes(modColuna);
            if (['TE', 'TME'].includes(descricao)) isEditable = [5, 6].includes(modColuna);
          } else if ([1, 4].includes(modoOperacaoId)) {
            if (descricao === 'TpM') isEditable = [1, 3, 5, 6].includes(modColuna);
            if (['TE', 'TME'].includes(descricao)) isEditable = [5, 6].includes(modColuna);
          } else if ([0, 3].includes(modoOperacaoId)) {
            if (descricao === 'TpM') isEditable = [1].includes(modColuna);
          }
        }

        if (validaPermissaoReadOnly('CadIntervaloPlano', 'intervalo_tpn_tpm')) {
          isEditable = false;
        }

        if (!isEditable) {
          if (list[cellInfo.index][cellInfo.column.id] !== 0) {
            const data = [...list];
            data[cellInfo.index][cellInfo.column.id] = 0;
            // Não chama setState aqui para evitar loops, a mutação direta é suficiente antes do render.
          }
          return (
            <div
              style={{
                textAlign: 'center',
                backgroundColor: '#eee',
                color: '#777',
                minHeight: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              -
            </div>
          );
        }

        let valorHTML = list[cellInfo.index][cellInfo.column.id];
        let classTpNZero = '';
        let classAv = '';
        let classAvM = '';

        if (cellInfo.original.descricao === 'TpN') {
          if (['1', '3', '5', '6', '7', '8'].indexOf(list[0][cellInfo.column.id]) >= 0) {
            valorHTML = parseFloat(list[cellInfo.index][cellInfo.column.id]).toFixed(0);
          } else {
            valorHTML = parseFloat(list[cellInfo.index][cellInfo.column.id]).toFixed(1);
          }
          if (isNaN(valorHTML)) valorHTML = 0; // CORREÇÃO: Evitar NaN
          classTpNZero = `class_tpn_${cellInfo.column.id}`;
        }
        if (cellInfo.original.descricao === 'TE' || cellInfo.original.descricao === 'TH') {
          classAv = `class_av_${cellInfo.column.id}`;
          valorHTML = parseFloat(list[cellInfo.index][cellInfo.column.id] / 10).toFixed(1);
        }
        if (cellInfo.original.descricao === 'TME') {
          classAvM = `class_avm_${cellInfo.column.id}`;
        }

        return (
          <div
            style={{ backgroundColor: '#fafafa', textAlign: 'center' }}
            contentEditable
            suppressContentEditableWarning
            className={`input-gridPlano class_borda_${cellInfo.column.id} ${classTpNZero} ${classAv} ${classAvM}`}
            onKeyDown={evento => {
              if (
                cellInfo.original.descricao === 'TpN' &&
                ['1', '3', '5', '6', '7', '8'].indexOf(list[0][cellInfo.column.id]) >= 0
              ) {
                return InputValidacao.validaSoNumeroInteiro(evento);
              }
              return InputValidacao.validaSoNumeroDecimal(evento);
            }}
            onFocus={e => {
              var cell = e.target;
              var range, selection;
              if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(cell);
                range.select();
              } else if (window.getSelection) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(cell);
                selection.removeAllRanges();
                selection.addRange(range);
              }
            }}
            onBlur={e => {
              if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_tpn_tpm') === '' && this._isMounted) {
                const data = [...list];
                if (data[cellInfo.index][cellInfo.column.id] !== e.target.innerHTML) {
                  let valorDigitado = e.target.innerHTML || 0;
                  if (cellInfo.original.descricao === 'TpN') {
                    valorDigitado = IntervaloValidacao.validaTempoIntervalo(data, cellInfo.column.id, valorDigitado);
                    data[cellInfo.index][cellInfo.column.id] = valorDigitado;
                    window.$(`.class_tpn_${cellInfo.column.id}`).css('border', 'solid #cccccc 2px');
                    window.$(`.class_tpn_${cellInfo.column.id}`).css('font-weight', 'normal');
                    window.$(`.class_tpn_${cellInfo.column.id}`).css('color', '#000000');
                    if (parseFloat(data[cellInfo.index][cellInfo.column.id]) <= 0) {
                      window.$(`.class_tpn_${cellInfo.column.id}`).css('border', 'solid #FF7F00 2px');
                      window.$(`.class_tpn_${cellInfo.column.id}`).css('font-weight', 'bold');
                      window.$(`.class_tpn_${cellInfo.column.id}`).css('color', '#FF0000');
                    }
                    e.target.innerHTML = data[cellInfo.index][cellInfo.column.id];
                    data[0].ciclo_maximo = IntervaloValidacao.getValorCicloMaximo(data, cellInfo.index);
                    data[0].ciclo_tempo_total = IntervaloValidacao.somaCicloTempoTotal(data);
                    for (var key in data) {
                      data[key].ciclo_maximo = data[0].ciclo_maximo;
                      this.handleDataChange(data);
                    }
                  } else {
                    if (cellInfo.original.descricao === 'TE' || cellInfo.original.descricao === 'TH') {
                      // Verifica se é a linha TE
                      let valorOriginal = data[cellInfo.index][cellInfo.column.id];
                      let valorDigitadoNumerico = parseFloat(e.target.innerHTML.replace(',', '.')) || 0;
                      const valorFinalBackend = Math.round(valorDigitadoNumerico * 10);
                      const valorFinalDisplay = (valorFinalBackend / 10).toFixed(1);

                      if (valorOriginal !== valorFinalBackend) {
                        // Compara com o valor * 10
                        if (valorDigitadoNumerico !== 0) {
                          // Comparação numérica direta
                          let vlAVM = parseInt(data[cellInfo.index + 1][cellInfo.column.id]);
                          // Usar uma nova variável para a lógica de inteiro para clareza
                          let valorInteiroParaLogica = parseInt(valorDigitadoNumerico);
                          valorInteiroParaLogica = valorInteiroParaLogica < 3 ? 3 : valorInteiroParaLogica;
                          vlAVM = vlAVM < 6 ? 6 : vlAVM;
                          vlAVM = vlAVM < valorInteiroParaLogica ? valorInteiroParaLogica : vlAVM;
                          data[cellInfo.index + 1][cellInfo.column.id] = vlAVM;
                        }
                        data[cellInfo.index][cellInfo.column.id] = valorFinalBackend; // Salva multiplicado por 10 e arredondado
                        this.handleDataChange(data);
                      }
                      e.target.innerHTML = valorFinalDisplay;
                      return; // Evita a lógica de salvamento genérica abaixo
                    }
                    if (cellInfo.original.descricao === 'TH') {
                      let valorOriginal = data[cellInfo.index][cellInfo.column.id];
                      let valorDigitadoNumerico = parseFloat(String(e.target.innerHTML).replace(',', '.')) || 0;

                      // Aplica a validação de range (0.1 a 19.9)
                      if (valorDigitadoNumerico < 0.1) valorDigitadoNumerico = 0.1;
                      if (valorDigitadoNumerico > 19.9) valorDigitadoNumerico = 19.9;

                      const valorFinalBackend = Math.round(valorDigitadoNumerico * 10);
                      const valorFinalDisplay = (valorFinalBackend / 10).toFixed(1);

                      // Atualiza o estado apenas se o valor mudou
                      if (valorOriginal !== valorFinalBackend) {
                        data[cellInfo.index][cellInfo.column.id] = valorFinalBackend;
                        this.handleDataChange(data);
                      }

                      // Sempre atualiza o innerHTML para garantir a formatação correta
                      e.target.innerHTML = valorFinalDisplay;
                      return;
                    }
                    // A lógica original para outras linhas como TME, etc., permanece aqui
                    if (cellInfo.original.descricao === 'TME') {
                      let vlAV = parseInt(data[cellInfo.index - 1][cellInfo.column.id]);
                      valorDigitado = parseInt(valorDigitado) < 6 ? 6 : valorDigitado;
                      if (vlAV > parseInt(valorDigitado)) {
                        valorDigitado = vlAV;
                      }
                    }
                    // Validação para TpM
                    if (cellInfo.original.descricao === 'TpM') {
                      let valorDigitadoTpM = e.target.innerHTML || 0;
                      valorDigitadoTpM = String(valorDigitadoTpM).replace(',', '.');
                      valorDigitadoTpM = IntervaloValidacao.validaTpMmenorTpN(
                        data,
                        cellInfo.column.id,
                        valorDigitadoTpM,
                      );
                      data[cellInfo.index][cellInfo.column.id] = valorDigitadoTpM;
                      e.target.innerHTML = valorDigitadoTpM;
                      this.handleDataChange(data);
                      return;
                    }

                    // Lógica de salvamento genérica para outras descrições não tratadas especificamente acima
                    // (caso a linha não seja 'TE' e nem 'TME' com tratamento especial)
                    if (data[cellInfo.index][cellInfo.column.id] !== e.target.innerHTML) {
                      data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML || 0;
                      this.handleDataChange(data);
                    }
                  }
                }
              }
            }}
            dangerouslySetInnerHTML={{ __html: valorHTML }}
          />
        );
      }
    } else {
      var classe = [
        'sel-nenhum',
        'sel-vermelho',
        'sel-amarelo',
        'sel-verde',
        'sel-vermelho-p',
        'sel-amarelo-p',
        'sel-verde-p',
      ];
      let faseDesabled = '';
      let faseAmareloDesabled = '';
      let faseVermelhoDesabled = '';
      let classFValida = '';
      let validacaoConflitanate = IntervaloValidacao.validaVerdeAmarelo(
        list,
        cellInfo.column.id,
        cellInfo.original.descricao,
      );
      if (parseInt(validacaoConflitanate) === 0) {
        faseDesabled = 'disabled';
        faseAmareloDesabled = 'disabled';
      } else if (parseInt(validacaoConflitanate) === 1) {
        faseDesabled = 'disabled';
      } else if (parseInt(validacaoConflitanate) === 3) {
        faseVermelhoDesabled = 'disabled';
      } else if (parseInt(validacaoConflitanate) === 4) {
        faseDesabled = 'disabled';
        faseVermelhoDesabled = 'disabled';
      }
      classFValida = `class_f_${cellInfo.original.descricao}_${cellInfo.column.id}`;

      return (
        <Select
          className={`select-gridPlano ${classe[valorAtual]} class_borda_${cellInfo.column.id} ${classFValida}`}
          contentEditable
          suppressContentEditableWarning
          onChange={event => {
            if (validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_mod_fase') === '' && this._isMounted) {
              const data = [...list];
              if (data[cellInfo.index][cellInfo.column.id] !== event.target.value) {
                this.setState({ chageChave: true });
                if ([2, 4].indexOf(parseInt(event.target.value)) >= 0) {
                  window.$(`.${classFValida}`).css('border', 'solid #cccccc 1px');
                }
                if (faseDesabled === '') {
                  data[cellInfo.index][cellInfo.column.id] = event.target.value;
                } else if (faseAmareloDesabled === '') {
                  if (['1', '2', '4', '5', '0'].indexOf(event.target.value) >= 0) {
                    data[cellInfo.index][cellInfo.column.id] = event.target.value;
                  }
                } else if (['1', '4', '0', '5'].indexOf(event.target.value) >= 0) {
                  data[cellInfo.index][cellInfo.column.id] = event.target.value;
                }
                this.handleDataChange(data);
              }
            }
          }}
          value={list[cellInfo.index][cellInfo.column.id]}
          disabled={validaPermissaoDisabled('CadIntervaloPlano', 'intervalo_mod_fase')}
        >
          <option value="1" disabled={faseVermelhoDesabled} className="sel-vermelho">
            1&nbsp;&nbsp;=&nbsp;&nbsp;Vermelho
          </option>
          <option value="2" disabled={faseAmareloDesabled} className="sel-amarelo">
            2&nbsp;&nbsp;=&nbsp;&nbsp;Amarelo
          </option>
          <option value="3" disabled={faseDesabled} className="sel-verde">
            3&nbsp;&nbsp;=&nbsp;&nbsp;Verde
          </option>
          <option value="4" className="sel-vermelho-p">
            4&nbsp;&nbsp;=&nbsp;&nbsp;Vermelho Piscante
          </option>
          <option value="5" className="sel-amarelo-p">
            5&nbsp;&nbsp;=&nbsp;&nbsp;Amarelo Piscante
          </option>
          <option value="6" disabled={faseDesabled} className="sel-verde-p">
            6&nbsp;&nbsp;=&nbsp;&nbsp;Verde Piscante
          </option>
          <option value="0" className="sel-nenhum">
            0&nbsp;&nbsp;=&nbsp;&nbsp;Apagado
          </option>
        </Select>
      );
    }
  }

  carregaColunas() {
    const intervalo = this.state.list.length > 0 ? this.state.list : [];
    if (!intervalo.length) return [];

    const modoOperacaoId = parseInt(intervalo[0].modo_operacao_id) || 0;
    var columns = [];
    this.countTempo = 0;
    this.segundos = 0.0;
    this.intervaloAnterior = 0;

    const linhasExibidas = this.state.list;

    columns.push({
      accessor: 'descricao',
      width: 40,
      style: { padding: '0px', height: '20px' },
      Header: () => (
        <div style={{ textAlign: 'center' }}>
          <i
            className="fa fa-question-circle help-icon"
            style={{ fontSize: '14px', cursor: 'pointer' }}
            onClick={this.handleShowLegendModal.bind(this)}
          />
        </div>
      ),
      Cell: props => {
        const descricao = props.value;
        const descriptions = {
          Mod: 'Modo do Intervalo',
          TpN: 'Tempo Normal',
          TpM: 'Tempo de Mínimo',
          ND: 'Número do Detector',
          SL: 'Sequência Lógica',
          TE: 'Tempo de Extensão',
          TME: 'Tempo Máximo de Extensão',
          TH: 'Tempo de Headway',
        };

        let tooltipText = descriptions[descricao];
        if (!tooltipText && descricao && descricao.startsWith('F')) {
          const faseNum = parseInt(descricao.substring(1));
          const faseDesc = (this.state.faseDescricoes || {})[faseNum];
          tooltipText = faseDesc ? `Fase ${faseNum}: ${faseDesc}` : `Fase ${faseNum}`;
        }

        return (
          <TooltipWrapper tooltipText={tooltipText}>
            <div style={{ textAlign: 'center' }}>{props.value}</div>
          </TooltipWrapper>
        );
      },
    });

    var property = intervalo[0];
    var numeroIntervalos = parseInt(property.numero_intervalo);

    for (var idColuna = 1; idColuna <= numeroIntervalos; idColuna++) {
      var key = `col_${idColuna}`;
      columns.push({
        Header: `${idColuna}`,
        headerClassName: `class_${idColuna} class_borda_${key}`,
        accessor: `${key}`,
        width: 34,
        style: { padding: '0px', height: '20px' },
        Cell: this.renderEditable,
      });
    }
    return columns;
  }

  piscaCores(faseId, corId) {
    if (this.segundoAtual !== parseInt(this.segundos)) {
      this.segundoAtual = parseInt(this.segundos);
      if (this.corIdAtual === corId) {
        window.$(`#imgSimulaF${faseId}`).attr('src', `${this.pngFase[0]}`);
        this.corIdAtual = 0;
      } else {
        window.$(`#imgSimulaF${faseId}`).attr('src', `${this.pngFase[corId]}`);
        this.corIdAtual = corId;
      }
    }
  }

  modoPiscante(data) {
    let piscanteCor =
      window.$(`#imgSimulaF${data[0].fase_id}`).attr('src') === this.pngFase[2] ? this.pngFase[0] : this.pngFase[2];
    for (const key in data) {
      window.$(`#imgSimulaF${data[key].fase_id}`).attr('src', `${piscanteCor}`);
    }
  }

  simulacao() {
    let cronometroIntervalo = 0;
    let faseIdx = this.numeroFaseAtual - this.coresFase.length + 1;
    if (this.segundos >= this.tempoIntervalo[this.countTempo]) {
      this.segundos = 0.0;
      this.countTempo += 1;
    }

    if (this.countTempo === 0) {
      window.$(`.class_${this.tempoIntervalo.length}`).css('background-color', '#ffffff');
    }
    window.$(`.class_${this.intervaloAnterior}`).css('background-color', '#ffffff');
    window.$(`.class_${parseInt(this.countTempo) + 1}`).css('background-color', '#FF7F00');
    window.$(`.class_borda_col_${this.intervaloAnterior}`).css('border', 'solid #cccccc 1px');
    window.$(`.class_borda_col_${parseInt(this.countTempo) + 1}`).css('border', 'solid #FF7F00 2px');
    this.intervaloAnterior = parseInt(this.countTempo) + 1;

    if (this.countTempo < this.tempoIntervalo.length) {
      this.segundos += 0.1;
      // Atualiza numeroFaseAtual com o número do intervalo atual
      this.numeroFaseAtual = this.countTempo + 1;
      // Força uma atualização do componente para refletir o novo valor
      this.forceUpdate();
      cronometroIntervalo = this.tempoIntervalo[this.countTempo] + 0.1 - this.segundos;
      window.$('#cronometro').val(cronometroIntervalo.toFixed(1));
      for (var x in this.coresFase) {
        if (['1', '2', '3'].indexOf(this.coresFase[x][this.countTempo]) >= 0) {
          window.$(`#imgSimulaF${faseIdx}`).attr('src', `${this.pngFase[this.coresFase[x][this.countTempo]]}`);
        } else {
          this.piscaCores(faseIdx, this.coresFase[x][this.countTempo]);
        }
        faseIdx++;
      }
    } else {
      this.countTempo = 0;
      this.segundos = 0.1;
      // Reseta numeroFaseAtual ao reiniciar o ciclo
      this.numeroFaseAtual = 0;
      this.forceUpdate();
      cronometroIntervalo = this.tempoIntervalo[this.countTempo] + 0.1 - this.segundos;
      window.$('#cronometro').val(cronometroIntervalo.toFixed(1));
      for (let x in this.coresFase) {
        window.$(`#imgSimulaF${parseInt(x) + 1}`).attr('src', `${this.pngFase[this.coresFase[x][this.countTempo]]}`);
      }
    }
  }

  iniciaSimulacao() {
    var corFase = '';
    this.segundos = 0.0;
    this.tempoIntervalo = [];
    this.pngFase[0] = trafficBranco;
    this.pngFase[1] = trafficRed;
    this.pngFase[2] = trafficYellow;
    this.pngFase[3] = trafficGreen;
    this.pngFase[4] = trafficRed;
    this.pngFase[5] = trafficYellow;
    this.pngFase[6] = trafficGreen;

    if (window.$('#btnSimular')[0].className.indexOf('success') > 0) {
      this.bloquearTela(true);
      this.setState({ disabledbtnTempoReal: true });
      this.numeroFaseAtual = 0; // Inicializa numeroFaseAtual
      const intervalo = this.state.list.length > 0 ? this.state.list : this.props.list || [];
      for (var key in intervalo) {
        if (intervalo[key]['descricao'] === 'TpN') {
          for (var x in intervalo[key]) {
            if (x.substring(0, 4) === 'col_') {
              this.tempoIntervalo.push(parseFloat(intervalo[key][x].replace('.', ',')));
            }
          }
        }
        if (intervalo[key]['descricao'][0] === 'F') {
          for (let x in intervalo[key]) {
            if (x.substring(0, 4) === 'col_') {
              corFase = corFase === '' ? parseInt(intervalo[key][x]) : corFase + ',' + parseInt(intervalo[key][x]);
            }
          }
          this.coresFase.push(corFase.split(','));
          corFase = '';
        }
      }
      this.nIntervId = setInterval(this.simulacao, 100);
      window.$('#btnSimular')[0].innerHTML = '<i class="fa fa-stop"></i> <span>Parar</span>';
      window.$('#btnSimular')[0].className = 'btn btn-danger form-control';
    } else {
      this.bloquearTela(false);
      this.setState({ disabledbtnTempoReal: false });
      this.numeroFaseAtual = 0; // Reseta numeroFaseAtual ao parar
      window.$(`.class_${parseInt(this.countTempo) + 1}`).css('background-color', '#ffffff');
      window.$(`.class_borda_col_${parseInt(this.countTempo) + 1}`).css('border', 'solid #cccccc 1px');
      this.intervaloAnterior = 0;
      this.segundos = 0.0;
      this.countTempo = 0;
      window.$('#cronometro').val(0);
      clearInterval(this.nIntervId);
      for (let x in this.coresFase) {
        window.$(`#imgSimulaF${parseInt(x) + 1}`).attr('src', `${traffic}`);
      }
      this.coresFase = [];
      window.$('#btnSimular')[0].innerHTML = '<i class="fa fa-play"></i> <span>Simular</span>';
      window.$('#btnSimular')[0].className = 'btn btn-success form-control';
    }
  }

  inputChange(event) {
    if (!this._isMounted) return;
    const data = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    for (var key in data) {
      data[key][event.target.name] = event.target.value;
      this.handleDataChange(data);
    }
  }

  cicloMaximoOnBlur(event) {
    if (!this._isMounted) return;
    const data = [...(this.state.list.length > 0 ? this.state.list : this.props.list || [])];

    const cicloTotal = parseFloat(IntervaloValidacao.somaCicloTempoTotal(data));
    const cicloMaximoMin = IntervaloValidacao.calculaCicloMaximo(data);
    const cicloMaximoMax = Math.floor(cicloTotal * 2);

    let valorDigitado = parseFloat(event.target.value) || 0;
    let novoCicloMaximo = valorDigitado;

    if (valorDigitado < cicloMaximoMin) {
      novoCicloMaximo = cicloMaximoMin;
      toastr.warning('Atenção', `O Ciclo Máximo deve ser no mínimo ${cicloMaximoMin}s (20% maior que o Ciclo Total).`);
    }

    if (novoCicloMaximo > cicloMaximoMax) {
      novoCicloMaximo = cicloMaximoMax;
      toastr.warning('Atenção', `O Ciclo Máximo não pode exceder 100% do Ciclo Total (${cicloMaximoMax}s).`);
    }

    if (novoCicloMaximo > 999) {
      novoCicloMaximo = 999;
    }

    for (var key in data) {
      data[key].ciclo_maximo = novoCicloMaximo;
    }
    this.handleDataChange(data);
  }

  copiarPlano() {
    if (!this._isMounted) return;
    let planoCopyId = window.$('#selIntervaloCopiaPlano').val();
    if (planoCopyId != null && planoCopyId > 0) {
      this.setState({ show: true });

      // 1. Guarda o Modo de Operação do plano de destino (o que está sendo editado)
      const planoDestino = this.state.list[0];
      const modoOperacaoDestino = planoDestino.modo_operacao_id;

      this.props
        .getList(this.state.dataControlador, planoCopyId, this.state.dataAnel)
        .then(({ payload }) => {
          if (this._isMounted) {
            let dataCopiada = payload.data;

            // 2. Captura o número de intervalos do plano copiado
            const numeroIntervalosCopiado = dataCopiada[0].numero_intervalo ? dataCopiada[0].numero_intervalo : 0;
            // 3. Itera sobre os dados copiados e ajusta as propriedades
            for (let key in dataCopiada) {
              // Mantém o ID do plano de destino
              dataCopiada[key].plano_id = this.state.dataPlano;
              // Força o modo de operação do plano de destino
              dataCopiada[key].modo_operacao_id = modoOperacaoDestino;
              // Atualiza o número de intervalos para incluir todas as colunas copiadas
              dataCopiada[key].numero_intervalo = numeroIntervalosCopiado;
              // O "Ciclo Máx." e a "Defasagem" são trazidos do plano copiado.
            }

            // 3. Filtra os dados copiados baseado no modo de operação de destino
            // Remove linhas que não devem existir no modo de destino
            const modoOperacaoDestinoInt = parseInt(modoOperacaoDestino) || 0;
            let dataFiltrada = dataCopiada.filter(row => {
              const descricao = row.descricao;

              // Linhas de fases e Mod devem aparecer em todos os modos
              if (descricao === 'Mod' || descricao.startsWith('F')) {
                return true;
              }

              if ([0, 3].includes(modoOperacaoDestinoInt)) {
                // Modos Isolado/Normal e Sincronizado/Normal: Exclui ND, TE, TME
                return !['ND', 'TE', 'TME'].includes(descricao);
              } else if ([1, 4].includes(modoOperacaoDestinoInt)) {
                // Isolado/Atuado, Sincronizado/Atuado: TpN, TpM, ND, TE, TME
                return ['TpN', 'TpM', 'ND', 'TE', 'TME'].includes(descricao);
              } else if ([2, 5].includes(modoOperacaoDestinoInt)) {
                // Modos atuados com Sequência Lógica: TpN, TpM, ND, SL, TE, TME
                return ['TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'].includes(descricao);
              } else if ([6, 7].includes(modoOperacaoDestinoInt)) {
                // Modos Adaptativo: TpN, TpM, ND, TH, TE, TME
                return ['TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'].includes(descricao);
              }
              return false;
            });

            // 4. Atualiza estado e salva automaticamente
            this.handleDataChange(dataFiltrada, {
              show: false,
              tableUpdateKey: Date.now(),
              controladorSalvo: false,
              sistemaSalvo: false,
              verificacaoControladorPendente: false,
              envioControladorErro: null,
              chageChave: true,
            });

            // 4.1. Força atualização do props.list também para manter consistência
            if (this.props.updateList) {
              this.props.updateList(dataFiltrada);
            }

            // 5. Salva automaticamente no banco após cópia
            this.salvaIntervaloDB()
              .then(() => {
                toastr.success('Sucesso', 'Intervalos copiados e salvos no banco. O Modo de Operação foi mantido.');
              })
              .catch(error => {
                toastr.warning(
                  'Atenção',
                  'Intervalos copiados, mas houve erro ao salvar automaticamente. Salve manualmente.',
                );
                console.error('Erro ao salvar após cópia:', error);
              });
          }
        })
        .catch(e => {
          if (this._isMounted) {
            this.setState({ show: false });
            toastr.error('Erro', 'Não foi possível copiar os dados do plano selecionado.');
          }
        });
    }
  }

  simulaTempoReal(data) {
    if (!this._isMounted) return;
    if (window.$('#btnTempoReal')[0].className && window.$('#btnTempoReal')[0].className.indexOf('info') < 0) {
      if (data.length) {
        const novoIntervalo = data[0].intervalo;

        // --- Lógica de Destaque da Tabela ---
        window.$(`.class_${this.intervaloTempoReal}`).css('background-color', '#ffffff');
        window.$(`.class_${this.intervaloTempoReal}`).css('font-weight', 'normal');
        window.$(`.class_${novoIntervalo}`).css('background-color', '#ff8000');
        window.$(`.class_${novoIntervalo}`).css('font-weight', 'bold');
        window.$(`.class_borda_col_${this.intervaloTempoReal}`).css('border', 'solid #cccccc 1px');
        window.$(`.class_borda_col_${novoIntervalo}`).css('border', 'solid #FF7F00 2px');
        this.intervaloTempoReal = novoIntervalo;

        // --- LÓGICA FINAL COM ESTADO (VERSÃO ROBUSTA) ---
        const tpnRow = this.state.list.find(row => row.descricao === 'TpN');
        const tpnDoIntervalo = tpnRow ? parseFloat(tpnRow[`col_${novoIntervalo}`]) || 0 : 0;
        const tempoTotalNoIntervaloAPI = parseFloat(data[0].tempo_intervalo) || 0;
        const tempoRestanteNoIntervaloAPI = parseFloat(data[0].tempo) || 0;

        let proximoModoDeEspera = this.state.emModoDeEspera;

        // A decisão do modo é tomada SOMENTE na troca de intervalo, usando o estado.
        if (novoIntervalo !== this.state.intervaloAnterior || tempoRestanteNoIntervaloAPI < 1) {
          // Verificar se há atuação real (botoeiras ou laços pressionados)
          const temAtuacao = data.some(
            fase =>
              fase.b1_pressionado ||
              fase.b2_pressionado ||
              fase.b3_pressionado ||
              fase.b4_pressionado ||
              fase.l1_pressionado ||
              fase.l2_pressionado ||
              fase.l3_pressionado ||
              fase.l4_pressionado ||
              fase.l5_pressionado ||
              fase.l6_pressionado ||
              fase.l7_pressionado ||
              fase.l8_pressionado ||
              fase.l9_pressionado ||
              fase.l10_pressionado ||
              fase.l11_pressionado ||
              fase.l12_pressionado ||
              fase.l13_pressionado ||
              fase.l14_pressionado ||
              fase.l15_pressionado ||
              fase.l16_pressionado,
          );

          // Nova lógica de extensão: só ativa se houver atuação E condições de tempo
          const isIntervaloVerde = data.some(fase => fase.fase_cor === 'Verde' && fase.intervalo === novoIntervalo);
          const isIntervaloAmarelo = data.some(fase => fase.fase_cor === 'Amarelo' && fase.intervalo === novoIntervalo);

          const condicaoTempo =
            tempoTotalNoIntervaloAPI > tpnDoIntervalo ||
            ((isIntervaloVerde || isIntervaloAmarelo) && tempoRestanteNoIntervaloAPI > tpnDoIntervalo * 0.5);

          proximoModoDeEspera = temAtuacao && condicaoTempo;
        }

        let valorParaCronometroTpN = 0;
        let valorParaCronometroExtensao = 0;

        if (proximoModoDeEspera) {
          // Em modo de espera (extensão), mantém o tempo do intervalo e o tempo de extensão
          valorParaCronometroTpN = tempoRestanteNoIntervaloAPI;
          valorParaCronometroExtensao = tempoRestanteNoIntervaloAPI;
        } else {
          valorParaCronometroTpN = tempoRestanteNoIntervaloAPI;
          valorParaCronometroExtensao = 0;
        }

        // --- Lógica dos Detectores ---
        const detectorPressed = id => {
          if (id >= 1 && id <= 8) return !!data[0][`b${id}_pressionado`];
          if (id >= 9 && id <= 24) return !!data[0][`l${id - 8}_pressionado`];
          return false;
        };

        for (let id = 1; id <= 24; id++) {
          window.$(`.class_nd_${id}`).css('background-color', detectorPressed(id) ? '#FF7F00' : '#FFFFFF');
        }

        // --- Lógica para Combinações de Detectores (Adaptativos) ---
        // Aplica cor laranja nas combinações quando os detectores correspondentes estão pressionados
        // Formato: 101-123 = pares consecutivos, 201-222 = trios consecutivos
        for (let i = 1; i <= 23; i++) {
          const combo2Value = 100 + i;
          const d1 = detectorPressed(i);
          const d2 = detectorPressed(i + 1);
          window.$(`.class_nd_${combo2Value}`).css('background-color', d1 && d2 ? '#FF7F00' : '#FFFFFF');
        }

        for (let i = 1; i <= 22; i++) {
          const combo3Value = 200 + i;
          const d1 = detectorPressed(i);
          const d2 = detectorPressed(i + 1);
          const d3 = detectorPressed(i + 2);
          window.$(`.class_nd_${combo3Value}`).css('background-color', d1 && d2 && d3 ? '#FF7F00' : '#FFFFFF');
        }

        // --- Atualização do Estado ---
        this.setState({
          emModoDeEspera: proximoModoDeEspera,
          intervaloAnterior: novoIntervalo, // Atualiza o intervalo anterior no estado
          cronometroTpN: Math.round(valorParaCronometroTpN),
          // cronometroExtensao é controlado apenas em executaTempoReal() para manter valor fixo
          modo: data[0].modo_operacao,
          tipoCiclo: data[0].tipo_ciclo,
          defasagem: data[0].defasagem,
          tempoDecorrido: Math.round(data[0].decorrente_ciclo),
        });

        this.numeroFaseAtual = this.intervaloTempoReal;
        this.forceUpdate();

        // --- Lógica das Cores das Fases ---
        if (data[0].mod_piscante) {
          this.modoPiscante(data);
        } else {
          for (const key in data) {
            if (data[key].fase_cor === 'Vermelho') {
              window.$(`#imgSimulaF${data[key].fase_id}`).attr('src', `${this.pngFase[1]}`);
            } else if (data[key].fase_cor === 'Amarelo') {
              window.$(`#imgSimulaF${data[key].fase_id}`).attr('src', `${this.pngFase[2]}`);
            } else if (data[key].fase_cor === 'Verde') {
              window.$(`#imgSimulaF${data[key].fase_id}`).attr('src', `${this.pngFase[3]}`);
            }
          }
        }
      }
      this.setState({ loop: 0 });
    }
  }

  executaIntermitente(data) {
    window.$('#btnTempoReal')[0].innerHTML = '<i class="fa fa-stop"></i> <span>Parar Tempo Real</span>';
    window.$('#btnTempoReal')[0].className = 'btn btn-danger form-control';
    // Animação visual
    this.intermitenteId = setInterval(() => {
      this.modoPiscante(data);
    }, 500);

    // Atualiza labels: plano_atu e tipo_ciclo do controlador, ant/pro da grade
    try {
      const d0 = (data && data[0]) || {};
      const grade = this._gradeCache || {};
      if (this._isMounted) {
        this.setState({
          planoAnteriorLabel: grade.anterior || d0.plano_ant || '',
          planoAtualLabel: d0.plano_atu || '',
          planoProximoLabel: grade.proximo || d0.plano_pro || '',
          tipoCiclo: d0.tipo_ciclo || 'Intermitente',
        });
      }
    } catch (_) {}

    // Limpa timers anteriores
    if (this.intermitenteHeartbeatId) clearInterval(this.intermitenteHeartbeatId);
    if (this.intermitenteNextTimeoutId) clearTimeout(this.intermitenteNextTimeoutId);

    // Agenda heartbeat leve para validar saída do intermitente
    this.intermitenteHeartbeatId = setInterval(() => {
      this.checkStatusIntermitente();
    }, 30000); // 30s

    // Agenda checagem na hora do próximo plano usando hora_proximo_plano do controlador
    this._agendarCheckProximoPlano(data);
  }

  // Filtra e ordena linhas do diagrama com base no modo de operação
  // Usado por iniciaTempoReal, executaTempoReal (planoMudou) e onChangeAnel
  _filtrarEOrdenarLinhas(dadosPlano) {
    const planoId =
      parseInt((dadosPlano[0] && (dadosPlano[0].plano_id || dadosPlano[0].id)) || this.state.dataPlano) || 0;
    if (planoId === 32) {
      return {
        linhasExibidas: this._criarDadosPlanoApagado(dadosPlano),
        modoOperacaoId: 0,
      };
    }

    const modoOperacaoId = parseInt(dadosPlano[0].modo_operacao_id) || 0;
    const faseIni = parseInt(dadosPlano[0] && (dadosPlano[0].fase_ini || dadosPlano[0].faseIni), 10) || 1;
    const faseFin = parseInt(dadosPlano[0] && (dadosPlano[0].fase_fin || dadosPlano[0].faseFin), 10) || 16;

    let linhasExibidas = dadosPlano.filter(row => {
      const descricao = row.descricao;
      if (descricao === 'Mod') return true;
      if (descricao && descricao.startsWith('F')) {
        const fId = parseInt(descricao.substring(1), 10);
        return fId >= faseIni && fId <= faseFin;
      }
      if ([0, 3].includes(modoOperacaoId)) return !['ND', 'TE', 'TME'].includes(descricao);
      if ([1, 4].includes(modoOperacaoId)) return ['TpN', 'TpM', 'ND', 'TE', 'TME'].includes(descricao);
      if ([2, 5].includes(modoOperacaoId)) return ['TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'].includes(descricao);
      if ([6, 7].includes(modoOperacaoId)) return ['TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'].includes(descricao);
      return false;
    });

    const fases = linhasExibidas
      .filter(row => row.descricao.startsWith('F'))
      .map(row => row.descricao)
      .sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));

    let desiredOrder;
    if ([1, 4].includes(modoOperacaoId)) {
      desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TE', 'TME'];
    } else if ([2, 5].includes(modoOperacaoId)) {
      desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'];
    } else if ([6, 7].includes(modoOperacaoId)) {
      desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'];
    } else {
      desiredOrder = ['Mod', ...fases, 'TpN', 'TpM'];
    }
    linhasExibidas.sort((a, b) => {
      const indexA = desiredOrder.indexOf(a.descricao);
      const indexB = desiredOrder.indexOf(b.descricao);
      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });

    return { linhasExibidas, modoOperacaoId };
  }

  // Agenda checagem na hora do próximo plano usando hora_proximo_plano do controlador
  _agendarCheckProximoPlano(data) {
    try {
      const d0 = (data && data[0]) || {};
      // hora_proximo_plano vem direto do controlador (bytes 25-27) no formato HH:MM:SS
      const horaProx = d0.hora_proximo_plano || '';
      const match = horaProx.match(/(\d{2}):(\d{2}):(\d{2})/);
      if (match) {
        if (this.intermitenteNextTimeoutId) clearTimeout(this.intermitenteNextTimeoutId);
        const now = new Date();
        const target = new Date();
        target.setHours(parseInt(match[1], 10));
        target.setMinutes(parseInt(match[2], 10));
        target.setSeconds(parseInt(match[3], 10));
        if (target.getTime() <= now.getTime()) target.setDate(target.getDate() + 1);
        let delay = target.getTime() - now.getTime() - 3000;
        if (delay < 1000) delay = 1000;
        const maxDelay = 2 * 60 * 60 * 1000;
        if (delay > maxDelay) delay = maxDelay;
        this.intermitenteNextTimeoutId = setTimeout(() => this.checkStatusIntermitente(), delay);
      }
    } catch (_) {}
  }

  // Checa estado no modo intermitente e decide se retoma o loop normal
  checkStatusIntermitente() {
    if (!this._isMounted) return;
    try {
      this.props
        .getControllerStep(this.state.dataNumControlador, this.state.dataAnel, this.state.dataGrupo)
        .then(result => {
          if (!this._isMounted || !result || !result.payload || !result.payload.data || !result.payload.data.length)
            return;
          const d0 = result.payload.data[0];

          // Atualiza labels: plano_atu/tipo_ciclo do controlador, ant/pro da grade
          if (this._isMounted) {
            const grade = this._gradeCache || {};
            if (d0.plano_forcado) {
              this.setState({
                planoAnteriorLabel: grade.anterior || d0.plano_ant || this.state.planoAnteriorLabel,
                planoAtualLabel: d0.plano_atu || this.state.planoAtualLabel,
                planoProximoLabel: grade.proximo || d0.plano_pro || this.state.planoProximoLabel,
              });
            } else {
              this.setState({
                planoAnteriorLabel: grade.anterior || d0.plano_ant || this.state.planoAnteriorLabel,
                planoAtualLabel: grade.atual || d0.plano_atu || this.state.planoAtualLabel,
                planoProximoLabel: grade.proximo || d0.plano_pro || this.state.planoProximoLabel,
              });
            }
          }

          if (!d0.mod_piscante) {
            // Saiu do intermitente: limpa timers auxiliares e retoma o loop normal
            if (this.intermitenteHeartbeatId) clearInterval(this.intermitenteHeartbeatId);
            if (this.intermitenteNextTimeoutId) clearTimeout(this.intermitenteNextTimeoutId);
            if (this.intermitenteId) clearInterval(this.intermitenteId);
            // Atualizar grade ao sair do intermitente
            this.props
              .getGradePlanos(this.state.dataControlador)
              .then(gradeResult => {
                if (!this._isMounted) return;
                if (gradeResult && gradeResult.payload && gradeResult.payload.data) {
                  this._gradeCache = gradeResult.payload.data;
                }
              })
              .catch(() => {});
            this.setState({ loop: 0, tempoRealAtivo: true }, () => this.executaTempoReal());
            return;
          }

          // Ainda em intermitente: reagenda timeout usando hora_proximo_plano do controlador
          this._agendarCheckProximoPlano(result.payload.data);
        })
        .catch(() => {});
    } catch (_) {}
  }

  _criarDadosPlanoApagado(dadosBase = [], controllerStepData = []) {
    const source = Array.isArray(dadosBase) ? JSON.parse(JSON.stringify(dadosBase)) : [];
    const rowMap = {};
    source.forEach(row => {
      if (row && row.descricao) {
        rowMap[row.descricao] = row;
      }
    });

    let fases = source
      .filter(row => row.descricao && row.descricao.startsWith('F'))
      .map(row => row.descricao)
      .sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));

    if (!fases.length && Array.isArray(controllerStepData) && controllerStepData.length) {
      fases = [
        ...new Set(controllerStepData.map(item => `F${parseInt(item.fase_id) || 0}`).filter(item => item !== 'F0')),
      ].sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));
    }

    if (!fases.length) {
      fases = ['F1', 'F2', 'F3'];
    }

    const faseIni = parseInt(fases[0].substring(1)) || 1;
    const faseFin = parseInt(fases[fases.length - 1].substring(1)) || faseIni;
    const descricoes = ['Mod', ...fases, 'TpN', 'TpM'];
    const basePadrao = source[0] || {};

    return descricoes.map(descricao => {
      const base = rowMap[descricao] || {};
      const modoOperacaoIdBase =
        base.modo_operacao_id !== undefined && base.modo_operacao_id !== null
          ? base.modo_operacao_id
          : basePadrao.modo_operacao_id;
      const row = {
        ...basePadrao,
        ...base,
        descricao,
        numero_intervalo: 4,
        ciclo_maximo: 0,
        ciclo_tempo_total: 0,
        defasagem: 0,
        decorrente_ciclo: 0,
        faseIni,
        faseFin,
        modo_operacao_id: parseInt(modoOperacaoIdBase) || 0,
        modo_operacao: base.modo_operacao || basePadrao.modo_operacao || this.state.modOperacaoDesc[0],
        tipo_ciclo: base.tipo_ciclo || basePadrao.tipo_ciclo || 'Normal',
        is_plano_apagado: true,
      };

      const modPattern = ['1', '2', '2', '2'];
      const tpnPattern = ['6', '3', '3', '3'];

      for (let idx = 1; idx <= consts.NUM_INTERVALO; idx++) {
        if (idx <= 4 && descricao === 'Mod') {
          row[`col_${idx}`] = modPattern[idx - 1];
        } else if (idx <= 4 && descricao === 'TpN') {
          row[`col_${idx}`] = tpnPattern[idx - 1];
        } else if (idx <= 4 && descricao === 'TpM') {
          row[`col_${idx}`] = '0';
        } else {
          row[`col_${idx}`] = idx <= 4 ? '0' : row[`col_${idx}`] || '0';
        }
      }

      return row;
    });
  }

  executaTempoReal() {
    if (!this._isMounted) return;
    window.$('#btnTempoReal')[0].innerHTML = '<i class="fa fa-stop"></i> <span>Parar Tempo Real</span>';
    window.$('#btnTempoReal')[0].className = 'btn btn-danger form-control';
    this.tempoRealId = setInterval(() => {
      if (!this._isMounted) {
        clearInterval(this.tempoRealId);
        return;
      }
      try {
        if (parseInt(this.state.loop) === 0) {
          this.setState({ tempoRealAtivo: true, loop: 1 });
          this.props
            .getControllerStep(this.state.dataNumControlador, this.state.dataAnel, this.state.dataGrupo)
            .catch(error => {
              if (this._isMounted) {
                this.setState({ tempoRealAtivo: false, loop: 0, show: false });
                this.bloquearTela(false);
                this.setState({ disabledbtnSimula: false });
                toastr.error('Erro', 'Dados incompletos. Conexão com o controlador foi perdida.');
                this.handleGetList();
              }
            })
            .then(result => {
              if (
                !this._isMounted ||
                !result ||
                !result.payload ||
                !result.payload.data ||
                result.payload.data.length === 0
              ) {
                this.setState({ tempoRealAtivo: false, loop: 0 });
                return;
              }

              // Atualiza labels de Plano (Anterior/Atual/Próximo) e Tipo do Ciclo vindos do tempo real
              try {
                // Filtrar pelo anel correto ao invés de pegar sempre data[0]
                const anelAtual = parseInt(this.state.dataAnel);
                const itemDoAnel = result.payload.data.find(item => parseInt(item.anel) === anelAtual);
                const d0 = itemDoAnel || result.payload.data[0] || {};

                if (this._isMounted) {
                  const grade = this._gradeCache || {};
                  if (d0.plano_forcado) {
                    // Plano forçado: plano_atu e tipo_ciclo do controlador, ant/pro da grade
                    this.setState({
                      planoAnteriorLabel: grade.anterior || d0.plano_ant || '',
                      planoAtualLabel: d0.plano_atu || '',
                      planoProximoLabel: grade.proximo || d0.plano_pro || '',
                      tipoCiclo: d0.tipo_ciclo || '',
                    });
                  } else {
                    // Operação normal: preferir labels da grade (com descrições) se disponível
                    this.setState({
                      planoAnteriorLabel: grade.anterior || d0.plano_ant || '',
                      planoAtualLabel: grade.atual || d0.plano_atu || '',
                      planoProximoLabel: grade.proximo || d0.plano_pro || '',
                      tipoCiclo: d0.tipo_ciclo || '',
                    });
                  }
                }
              } catch (e) {}

              // Atualiza T. Extensão com valor de extensao_seg do tempo real
              try {
                const ext = parseInt(result.payload.data[0].extensao_seg) || 0;
                const intervaloAtual = parseInt(result.payload.data[0].intervalo) || 1;
                const intervaloAnterior = this.intervaloTempoReal || 0;

                if (this._isMounted) {
                  // Se houve troca de intervalo OU voltou para intervalo 1, força o valor do backend
                  if (intervaloAnterior !== intervaloAtual || (intervaloAtual === 1 && ext === 0)) {
                    this.setState({ cronometroExtensao: ext });
                  }
                  // Se há extensão ativa (> 0), atualiza o valor independente do intervalo
                  else if (ext > 0) {
                    this.setState({ cronometroExtensao: ext });
                  }
                  // Força sincronização: se backend zerou mas front não, corrige
                  else if (ext === 0 && this.state.cronometroExtensao > 0) {
                    this.setState({ cronometroExtensao: 0 });
                  }
                }
              } catch (_) {}

              const novoPlanoId = parseInt(result.payload.data[0].plano_id);
              const planoAtualState = parseInt(this.state.tempoRealPlano) || 0;

              const isPiscaChave = result.payload.data.some(item => item.modo_operacao === 'Pisca Chave');
              const d0 = result.payload.data[0] || {};
              const isPlanoForcado = !!d0.plano_forcado;
              const planoForcadoId = parseInt(d0.plano_forcado_id_hw) || 0;
              const isPlanoForcadoApagado = isPlanoForcado && planoForcadoId === 32;
              const isPlanoApagadoAtivo = novoPlanoId === 32 || isPlanoForcadoApagado;

              if (isPiscaChave) {
                clearInterval(this.tempoRealId);
                this.setState({ loop: 0, tempoRealAtivo: false }, () => {
                  this.executaPiscaChave(result.payload.data);
                });
                return;
              } else if (isPlanoApagadoAtivo) {
                const dadosPlanoApagado = this._criarDadosPlanoApagado(
                  this.state.list.length > 0 ? this.state.list : this.props.list || [],
                  result.payload.data,
                );

                this.handleDataChange(dadosPlanoApagado, {
                  show: false,
                  loop: 0,
                  tempoRealPlano: 32,
                  dataPlano: 32,
                  titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                    result.payload.data[0].anel
                  } - Plano Apagado`,
                  cronometroTpN: 0,
                  cronometroExtensao: 0,
                  tempoDecorrido: 0,
                  defasagem: 0,
                  tipoCiclo: d0.tipo_ciclo || 'Normal',
                  modo: this.state.modOperacaoDesc[0],
                });
                return;
              } else if ([49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63].indexOf(novoPlanoId) >= 0) {
                // Plano intermitente detectado
                this.setState({
                  tempoRealPlano: novoPlanoId,
                  titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                    result.payload.data[0].anel
                  } - Intermitente`,
                });
                this.executaIntermitente(result.payload.data);
              } else if (novoPlanoId === 0) {
                this.setState({ loop: 0 });
              } else {
                const planoMudou = planoAtualState !== novoPlanoId;

                if (planoMudou) {
                  // Definir título baseado no tipo de plano (usando flags do controlador)
                  let titulo;
                  if (isPlanoForcadoApagado) {
                    titulo = `Controlador ${this.state.dataNumControlador} - Anel ${
                      result.payload.data[0].anel
                    } - Plano Apagado`;
                  } else if (isPlanoForcado) {
                    titulo = `Controlador ${this.state.dataNumControlador} - Anel ${
                      result.payload.data[0].anel
                    } - Plano Forçado`;
                  } else {
                    titulo = this.formatarTitulo(
                      this.state.dataNumControlador,
                      result.payload.data[0].anel,
                      novoPlanoId,
                    );
                  }

                  this.setState({
                    show: true,
                    tempoRealPlano: novoPlanoId,
                    dataPlano: result.payload.data[0].plano_id,
                    titulo: titulo,
                  });

                  // Atualizar grade de troca de planos (labels com descrições)
                  this.props
                    .getGradePlanos(this.state.dataControlador)
                    .then(gradeResult => {
                      if (!this._isMounted) return;
                      if (gradeResult && gradeResult.payload && gradeResult.payload.data) {
                        const grade = gradeResult.payload.data;
                        this._gradeCache = grade;
                        if (!d0.plano_forcado) {
                          this.setState({
                            planoAnteriorLabel: grade.anterior || '',
                            planoAtualLabel: grade.atual || '',
                            planoProximoLabel: grade.proximo || '',
                          });
                        }
                      }
                    })
                    .catch(() => {});

                  // Se é plano forçado (qualquer) ou plano especial (32/49..63), não tenta carregar dados de intervalos
                  const isPlanoEspecial = [32, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63].includes(
                    novoPlanoId,
                  );

                  if (isPlanoForcado && planoForcadoId > 0 && planoForcadoId < 49) {
                    // Plano forçado normal (1-48): carregar diagrama do plano forçado
                    this.props
                      .getList(result.payload.data[0].controlador_id, planoForcadoId, this.state.dataAnel)
                      .then(listResult => {
                        if (!this._isMounted || !listResult.payload || !listResult.payload.data) {
                          this.setState({
                            show: false,
                            tempoRealAtivo: false,
                            loop: 0,
                          });
                          return;
                        }

                        const dadosPlano = listResult.payload.data;
                        const { linhasExibidas, modoOperacaoId } = this._filtrarEOrdenarLinhas(dadosPlano);

                        this.handleDataChange(
                          linhasExibidas,
                          {
                            show: false,
                            loop: 0,
                          },
                          () => {
                            this.forceTableUpdate();
                            if (dadosPlano[0] && dadosPlano[0].modo_operacao_id !== undefined) {
                              window
                                .$('#modooperacaointervaloplano')
                                .html(this.state.modOperacaoDesc[dadosPlano[0].modo_operacao_id]);
                            }
                            this.simulaTempoReal(result.payload.data, false);
                          },
                        );
                      })
                      .catch(error => {
                        if (this._isMounted) {
                          this.setState({
                            tempoRealAtivo: false,
                            show: false,
                            loop: 0,
                            modo: '',
                          });
                          this.bloquearTela(false);
                          this.setState({ disabledbtnSimula: false });
                          toastr.error('Erro', 'Falha ao carregar dados do plano forçado.');
                          this.handleGetList();
                        }
                      });
                  } else if (isPlanoForcadoApagado || novoPlanoId === 32) {
                    const dadosPlanoApagado = this._criarDadosPlanoApagado(
                      this.state.list.length > 0 ? this.state.list : this.props.list || [],
                      result.payload.data,
                    );

                    this.handleDataChange(dadosPlanoApagado, {
                      show: false,
                      loop: 0,
                      cronometroTpN: 0,
                      cronometroExtensao: 0,
                      tempoDecorrido: 0,
                      defasagem: 0,
                      tipoCiclo: d0.tipo_ciclo || 'Normal',
                    });
                  } else if (isPlanoForcado || isPlanoEspecial) {
                    this.setState({
                      show: false,
                      loop: 0,
                    });
                    // Apenas simula o tempo real sem carregar dados de intervalos
                    this.simulaTempoReal(result.payload.data, false);
                  } else {
                    // Comportamento normal: carrega dados de intervalos
                    this.props
                      .getList(
                        result.payload.data[0].controlador_id,
                        result.payload.data[0].plano_id,
                        this.state.dataAnel,
                      )
                      .then(listResult => {
                        if (!this._isMounted || !listResult.payload || !listResult.payload.data) {
                          this.setState({
                            show: false,
                            tempoRealAtivo: false,
                            loop: 0,
                          });
                          return;
                        }

                        const dadosPlano = listResult.payload.data;
                        const { linhasExibidas, modoOperacaoId } = this._filtrarEOrdenarLinhas(dadosPlano);

                        this.handleDataChange(
                          linhasExibidas,
                          {
                            show: false,
                            loop: 0,
                          },
                          () => {
                            this.forceTableUpdate();
                            if (dadosPlano[0] && dadosPlano[0].modo_operacao_id !== undefined) {
                              window
                                .$('#modooperacaointervaloplano')
                                .html(this.state.modOperacaoDesc[dadosPlano[0].modo_operacao_id]);
                            }
                            this.simulaTempoReal(result.payload.data, false);
                          },
                        );
                      })
                      .catch(error => {
                        if (this._isMounted) {
                          this.setState({
                            tempoRealAtivo: false,
                            show: false,
                            loop: 0,
                            modo: '',
                          });
                          this.bloquearTela(false);
                          this.setState({ disabledbtnSimula: false });
                          toastr.error('Erro', 'Falha ao carregar dados do plano.');
                          this.handleGetList();
                        }
                      });
                  }
                } else {
                  this.simulaTempoReal(result.payload.data, false);
                  this.setState({ loop: 0 });
                }
              }
            });
        }
      } catch (error) {
        console.error('Erro no executaTempoReal:', error);
        if (this._isMounted) this.setState({ loop: 0 });
      }
    }, 500);
  }

  iniciaTempoReal() {
    if (!this._isMounted) return;
    this.pngFase[0] = trafficBranco;
    this.pngFase[1] = trafficRed;
    this.pngFase[2] = trafficYellow;
    this.pngFase[3] = trafficGreen;
    this.pngFase[4] = trafficRed;
    this.pngFase[5] = trafficYellow;
    this.pngFase[6] = trafficGreen;

    if (window.$('#btnTempoReal')[0].className.indexOf('info') > 0) {
      this.setState({
        disabledbtnSimula: true,
        show: true,
        tempoRealAtivo: true,
        tempoRealPlano: null,
        loop: 0,
      });
      this.bloquearTela(true);
      this.props
        .getControllerStep(this.state.dataNumControlador, this.state.dataAnel, this.state.dataGrupo)
        .then(result => {
          if (
            !this._isMounted ||
            !result ||
            !result.payload ||
            !result.payload.data ||
            result.payload.data.length === 0
          ) {
            this.setState({ show: false, tempoRealAtivo: false });
            this.bloquearTela(false);
            this.setState({ disabledbtnSimula: false });
            toastr.error('Erro', 'Dados incompletos do controlador.');
            return;
          }
          this.totalFases = result.payload.data.length;
          const planoId = parseInt(result.payload.data[0].plano_id);
          const d0 = result.payload.data[0] || {};
          this.setState({
            tempoRealPlano: planoId,
            dataPlano: result.payload.data[0].plano_id,
            titulo: this.formatarTitulo(this.state.dataNumControlador, result.payload.data[0].anel, planoId),
          });
          this.bloquearTela(true);

          // Buscar grade de troca de planos 1 vez (labels com descrições)
          this.props
            .getGradePlanos(this.state.dataControlador)
            .then(gradeResult => {
              if (!this._isMounted) return;
              if (gradeResult && gradeResult.payload && gradeResult.payload.data) {
                const grade = gradeResult.payload.data;
                this._gradeCache = grade;
                if (d0.plano_forcado) {
                  // Plano forçado: plano_atu do controlador, ant/pro da grade
                  this.setState({
                    planoAnteriorLabel: grade.anterior || d0.plano_ant || '',
                    planoAtualLabel: d0.plano_atu || '',
                    planoProximoLabel: grade.proximo || d0.plano_pro || '',
                  });
                } else {
                  // Normal: todos os labels da grade
                  this.setState({
                    planoAnteriorLabel: grade.anterior || d0.plano_ant || '',
                    planoAtualLabel: grade.atual || d0.plano_atu || '',
                    planoProximoLabel: grade.proximo || d0.plano_pro || '',
                  });
                }
              }
            })
            .catch(() => {
              // Fallback: usar labels do controlador se a grade falhar
              if (this._isMounted) {
                this.setState({
                  planoAnteriorLabel: d0.plano_ant || '',
                  planoAtualLabel: d0.plano_atu || '',
                  planoProximoLabel: d0.plano_pro || '',
                });
              }
            });

          // Determinar título usando flags do controlador
          const isPlanoForcado = !!d0.plano_forcado;
          const planoForcadoIdHw = parseInt(d0.plano_forcado_id_hw) || 0;
          const isIntermitenteOuEspecial = planoId >= 32 && planoId <= 63;

          if (isPlanoForcado && planoForcadoIdHw === 32) {
            this.setState({
              titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                result.payload.data[0].anel
              } - Plano Apagado`,
            });
          } else if (isPlanoForcado) {
            this.setState({
              titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                result.payload.data[0].anel
              } - Plano Forçado`,
            });
          } else if (d0.mod_piscante || (planoId >= 49 && planoId <= 63)) {
            this.setState({
              titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                result.payload.data[0].anel
              } - Intermitente`,
            });
          }

          const isPiscaChave = result.payload.data.some(item => item.modo_operacao === 'Pisca Chave');

          if (isPiscaChave) {
            // Pisca Chave: inicia animação direto
            this.setState({ show: false });
            this.executaPiscaChave(result.payload.data);
          } else if (isIntermitenteOuEspecial && !isPlanoForcado) {
            // Plano especial (intermitente/apagado) sem ser forçado: inicia tempo real direto (sem carregar diagrama)
            this.setState({ show: false });
            this.executaTempoReal();
          } else if (isPlanoForcado && planoForcadoIdHw > 0 && planoForcadoIdHw < 49) {
            // Plano forçado normal (1-48): carregar diagrama do plano forçado
            this.props
              .getList(this.state.dataControlador, planoForcadoIdHw, this.state.dataAnel)
              .then(listResult => {
                if (!this._isMounted || !listResult.payload || !listResult.payload.data) {
                  this.setState({ show: false, tempoRealAtivo: false });
                  this.bloquearTela(false);
                  this.setState({ disabledbtnSimula: false });
                  toastr.error('Erro', 'Dados incompletos do plano forçado.');
                  return;
                }

                const dadosPlano = listResult.payload.data;
                const { linhasExibidas, modoOperacaoId } = this._filtrarEOrdenarLinhas(dadosPlano);

                const anelAtual = parseInt(this.state.dataAnel);
                const itemDoAnel = result.payload.data.find(item => parseInt(item.anel) === anelAtual);
                const tipoCicloTempoReal =
                  (itemDoAnel ? itemDoAnel.tipo_ciclo : result.payload.data[0].tipo_ciclo) || '';

                this.handleDataChange(
                  linhasExibidas,
                  {
                    show: false,
                    tipoCiclo: tipoCicloTempoReal,
                  },
                  () => {
                    this.forceTableUpdate();
                    if (dadosPlano[0] && dadosPlano[0].modo_operacao_id !== undefined) {
                      window
                        .$('#modooperacaointervaloplano')
                        .html(this.state.modOperacaoDesc[dadosPlano[0].modo_operacao_id]);
                    }
                    this.executaTempoReal();
                  },
                );
              })
              .catch(error => {
                if (this._isMounted) {
                  this.setState({ show: false, tempoRealAtivo: false });
                  this.bloquearTela(false);
                  this.setState({ disabledbtnSimula: false });
                  toastr.error('Erro', 'Falha ao carregar dados do plano forçado.');
                  this.handleGetList();
                }
              });
          } else if (isPlanoForcado) {
            // Plano forçado especial (apagado/intermitente): inicia tempo real direto
            this.setState({ show: false });
            this.executaTempoReal();
          } else {
            // Plano normal: carregar diagrama e depois iniciar tempo real
            this.props
              .getList(this.state.dataControlador, result.payload.data[0].plano_id, this.state.dataAnel)
              .then(listResult => {
                if (!this._isMounted || !listResult.payload || !listResult.payload.data) {
                  this.setState({ show: false, tempoRealAtivo: false });
                  this.bloquearTela(false);
                  this.setState({ disabledbtnSimula: false });
                  toastr.error('Erro', 'Dados incompletos do plano.');
                  return;
                }

                const dadosPlano = listResult.payload.data;
                const { linhasExibidas, modoOperacaoId } = this._filtrarEOrdenarLinhas(dadosPlano);

                const anelAtual = parseInt(this.state.dataAnel);
                const itemDoAnel = result.payload.data.find(item => parseInt(item.anel) === anelAtual);
                const tipoCicloTempoReal =
                  (itemDoAnel ? itemDoAnel.tipo_ciclo : result.payload.data[0].tipo_ciclo) || '';

                this.handleDataChange(
                  linhasExibidas,
                  {
                    show: false,
                    tipoCiclo: tipoCicloTempoReal,
                  },
                  () => {
                    this.forceTableUpdate();
                    if (dadosPlano[0] && dadosPlano[0].modo_operacao_id !== undefined) {
                      window
                        .$('#modooperacaointervaloplano')
                        .html(this.state.modOperacaoDesc[dadosPlano[0].modo_operacao_id]);
                    }
                    this.executaTempoReal();
                  },
                );
              })
              .catch(error => {
                if (this._isMounted) {
                  this.setState({ show: false, tempoRealAtivo: false });
                  this.bloquearTela(false);
                  this.setState({ disabledbtnSimula: false });
                  toastr.error('Erro', 'Falha ao carregar dados do plano.');
                  this.handleGetList();
                }
              });
          }
        })
        .catch(error => {
          if (this._isMounted) {
            this.setState({ show: false, tempoRealAtivo: false });
            this.bloquearTela(false);
            this.setState({ disabledbtnSimula: false });
            toastr.error('Erro', 'Dados incompletos. Conexão com o controlador foi perdida.');
            this.handleGetList();
          }
        });
    } else {
      this.pararTempoReal();
    }
  }

  executaPiscaChave(data) {
    if (!this._isMounted) return;

    window.$('#btnTempoReal')[0].innerHTML = '<i class="fa fa-stop"></i> <span>Parar Tempo Real</span>';
    window.$('#btnTempoReal')[0].className = 'btn btn-danger form-control';

    // Limpar destaque da tabela antes de iniciar Pisca Chave
    if (this.intervaloTempoReal) {
      window.$(`.class_${this.intervaloTempoReal}`).css('background-color', '#ffffff');
      window.$(`.class_${this.intervaloTempoReal}`).css('font-weight', 'normal');
      window.$(`.class_borda_col_${this.intervaloTempoReal}`).css('border', 'solid #cccccc 1px');
    }

    this.setState({
      modo: data[0].modo_operacao,
      tipoCiclo: 'Chave Piscante Ativa',
      defasagem: 0,
      tempoDecorrido: 0,
      cronometroTpN: 0,
      cronometroExtensao: '',
      titulo: `Controlador ${this.state.dataNumControlador} - Anel ${data[0].anel} - Chave Piscante Ativa`,
    });

    this.tempoRealId = setInterval(() => {
      if (!this._isMounted) {
        clearInterval(this.tempoRealId);
        return;
      }

      try {
        if (parseInt(this.state.loop) === 0) {
          this.setState({ tempoRealAtivo: true, loop: 1 });

          this.props
            .getControllerStep(this.state.dataNumControlador, this.state.dataAnel, this.state.dataGrupo)
            .catch(error => {
              if (this._isMounted) {
                this.setState({ tempoRealAtivo: false, loop: 0, show: false });
                this.bloquearTela(false);
                this.setState({ disabledbtnSimula: false });
                toastr.error('Erro', 'Dados incompletos. Conexão com o controlador foi perdida.');
                this.handleGetList();
              }
            })
            .then(result => {
              if (
                !this._isMounted ||
                !result ||
                !result.payload ||
                !result.payload.data ||
                result.payload.data.length === 0
              ) {
                this.setState({ tempoRealAtivo: false, loop: 0 });
                return;
              }

              const isPiscaChave = result.payload.data.some(item => item.modo_operacao === 'Pisca Chave');

              if (!isPiscaChave) {
                const novoPlanoId = parseInt(result.payload.data[0].plano_id);
                if (novoPlanoId === 0) {
                  this.setState({ loop: 0 });
                  return;
                }

                clearInterval(this.tempoRealId);
                this.setState(
                  {
                    tempoRealPlano: novoPlanoId,
                    dataPlano: novoPlanoId,
                    titulo: `Controlador ${this.state.dataNumControlador} - Anel ${
                      result.payload.data[0].anel
                    } - Plano ${novoPlanoId}`,
                  },
                  () => {
                    this.setState({ loop: 0, tempoRealAtivo: false }, () => {
                      this.executaTempoReal();
                    });
                  },
                );
                return;
              }

              this.modoPiscante(result.payload.data);

              this.setState({ loop: 0 });
            });
        }
      } catch (error) {
        console.error('Erro no executaPiscaChave:', error);
        if (this._isMounted) this.setState({ loop: 0 });
      }
    }, 100);
  }

  pararTempoReal() {
    if (!this._isMounted) return;
    this.bloquearTela(false);
    this._gradeCache = null;
    this.setState({
      disabledbtnSimula: false,
      tempoRealAtivo: false,
      tempoDecorrido: 0,
      cronometroExtensao: 0,
    });
    this.numeroFaseAtual = 0;
    this.forceUpdate();
    window.$(`.class_${this.intervaloTempoReal}`).css('background-color', '#ffffff');
    window.$(`.class_${this.intervaloTempoReal}`).css('font-weight', 'normal');
    window.$(`.class_borda_col_${this.intervaloTempoReal}`).css('border', 'solid #cccccc 1px');
    window.$('#cronometro').val(0);
    clearInterval(this.tempoRealId);
    clearInterval(this.intermitenteId);
    if (this.intermitenteHeartbeatId) clearInterval(this.intermitenteHeartbeatId);
    if (this.intermitenteNextTimeoutId) clearTimeout(this.intermitenteNextTimeoutId);
    for (let index = 1; index <= this.totalFases; index++) {
      window.$(`#imgSimulaF${index}`).attr('src', `${traffic}`);
    }
    if (this.props['data-plano'] !== this.state.dataPlano) {
      this.setState({ dataPlano: this.props['data-plano'] }, () => {
        this.props.getList(this.state.dataControlador, this.props['data-plano'], this.state.dataAnel).then(result => {
          if (this._isMounted) {
            this.handleDataChange(
              result.payload.data,
              {
                modo: '',
                tempoRealAtivo: false,
                tempoDecorrido: 0,
                titulo: this.formatarTitulo(
                  this.state.dataNumControlador,
                  this.state.dataAnel,
                  this.props['data-plano'],
                ),
              },
              this.forceTableUpdate,
            );
          }
        });
      });
    }
    window.$('#btnTempoReal')[0].innerHTML = '<i class="fa fa-play"></i> <span>Tempo Real</span>';
    window.$('#btnTempoReal')[0].className = 'btn btn-info form-control';
  }

  bloquearTela(bloquear) {
    if (!this._isMounted) return;
    this.setState({ disabledbtn: bloquear });
    if (bloquear) {
      // Desabilitar todos os selects, exceto o de anel (ID: selectAnel)
      window
        .$('select')
        .not('#selectAnel')
        .attr('disabled', 'disabled');
      window.$('div .input-gridPlano').attr('contenteditable', 'false');
      window.$('input').attr('disabled', 'disabled');
    } else {
      window.$('select').removeAttr('disabled');
      window.$('div .input-gridPlano').attr('contenteditable', 'true');
      window.$('input').removeAttr('disabled');
    }
  }

  adicionaIntervalo(column_id) {
    if (!this._isMounted) return;

    let data = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    column_id = column_id.split('_');
    let colData = {};
    let colId = 0;
    let colCount = parseInt(column_id[1]);

    if (parseInt(data[0].numero_intervalo) < consts.NUM_INTERVALO) {
      for (const idx in data) {
        colData = {};
        for (const key in data[idx]) {
          if (key.indexOf('col_') >= 0) {
            colId = parseInt(key.split('_')[1]);
            if (colId === colCount) {
              colData[key] = data[idx][key];
              if (data[idx].descricao === 'Mod') {
                colData[`col_${colId + 1}`] = '2';
              } else if (data[idx].descricao[0] === 'F') {
                colData[`col_${colId + 1}`] = '1';
              } else if (data[idx].descricao === 'TpN') {
                colData[`col_${colId + 1}`] = data[1].tempo_vermelho_min || '5';
              } else if (data[idx].descricao === 'ND') {
                colData[`col_${colId + 1}`] = '0';
              } else if (data[idx].descricao === 'TpM') {
                colData[`col_${colId + 1}`] = '0';
              } else if (data[idx].descricao === 'TE') {
                colData[`col_${colId + 1}`] = '0';
              } else if (data[idx].descricao === 'TME') {
                colData[`col_${colId + 1}`] = '0';
              }

              if (parseInt(data[0].numero_intervalo) === colId) {
                colId++;
              }
            } else if (colId < colCount) {
              colData[key] = data[idx][key];
            } else {
              colId++;
              colData[`col_${colId}`] = data[idx][key];
            }
          } else {
            colData[key] = data[idx][key];
          }
        }
        data[idx] = colData;
      }

      data[0].numero_intervalo++;
      if (this._isMounted) {
        this.handleDataChange(data, { tableUpdateKey: Date.now() });
      }
    } else {
      toastr.warning('Alerta', 'O número máximo de intervalos permitido é 48');
    }
  }

  removeIntervalo(column_id) {
    if (!this._isMounted) return;

    let data = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    column_id = column_id.split('_');
    let colData = {};
    let colId = 0;
    let colApaga = true;
    let columnId = parseInt(column_id[1]);

    if (parseInt(data[0].numero_intervalo) > 4) {
      for (const idx in data) {
        for (const key in data[idx]) {
          if (key.indexOf('col_') >= 0) {
            let validacaoConflitanate = IntervaloValidacao.validaVerdeAmarelo(
              data,
              `col_${columnId}`,
              data[idx].descricao,
            );
            if (parseInt(validacaoConflitanate) === 0) {
              colApaga = false;
            }
          }
        }
      }

      if (colApaga) {
        for (const idx in data) {
          colData = {};
          for (const key in data[idx]) {
            if (key.indexOf('col_') >= 0) {
              colId = parseInt(key.split('_')[1]);
              if (colId === columnId) {
                if (data[idx].descricao === 'Mod') {
                  if (
                    [1, 3].indexOf(parseInt(data[idx][`col_${colId + 1}`])) >= 0 ||
                    [1, 3].indexOf(parseInt(data[idx][`col_${colId - 1}`])) >= 0
                  ) {
                    colApaga = false;
                  }
                }

                if (!colApaga) {
                  colData[key] = data[idx][key];
                  if (parseInt(data[0].numero_intervalo) === colId) {
                    toastr.warning(
                      'Alerta',
                      'Não é possível remover um intervalo antes ou depois de um "Principal" ou "Atuado"',
                    );
                  }
                } else if (parseInt(data[0].numero_intervalo) === colId) {
                  colId--;
                }
              } else if (colId < columnId) {
                colData[key] = data[idx][key];
              } else {
                if (colApaga) {
                  colId--;
                } else {
                  toastr.warning(
                    'Alerta',
                    'Não é possível remover um intervalo antes ou depois de um "Principal" ou "Atuado"',
                  );
                }
                colData[`col_${colId}`] = data[idx][key];
              }
            } else {
              colData[key] = data[idx][key];
            }
          }
          data[idx] = colData;
        }

        if (colApaga) {
          data[0].numero_intervalo--;
          if (this._isMounted) {
            this.handleDataChange(data, { tableUpdateKey: Date.now() });
          }
        }
      } else {
        toastr.warning('Alerta', 'Não é possível remover o intervalo, existem fases conflitantes');
      }
    } else {
      toastr.warning('Alerta', 'O número mínimo de intervalos permitido é 4');
    }
  }

  handleShowLegendModal() {
    if (this._isMounted) {
      this.setState({ showLegendModal: true });
    }
  }

  handleCloseLegendModal() {
    if (this._isMounted) {
      this.setState({ showLegendModal: false });
    }
  }

  exibeImagem(faseIni, faseFin) {
    let listImg = [];
    const trafficImage = this.state.planoApagado ? trafficBranco : traffic;
    for (let idx = faseIni; idx <= faseFin; idx++) {
      listImg.push(<img key={`imgSimulaF${idx}`} id={`imgSimulaF${idx}`} src={trafficImage} height="64" alt="" />);
    }
    return listImg;
  }

  async generateReportProgramacao(iPlano) {
    try {
      const html = await generateReport(this.state.dataControlador, this.state.dataGrupo, iPlano);
      var janelaImprimir = window.open('', '', 'width=800,height=600');
      janelaImprimir.document.open();
      janelaImprimir.document.write(html);
      janelaImprimir.document.close();
      janelaImprimir.print();
      janelaImprimir.close();
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      toastr.error('Erro', 'Falha ao gerar o relatório.');
    }
  }

  async onChangeAnel(event) {
    if (!this._isMounted) return;

    const selectedOption = event.target.options[event.target.selectedIndex];
    const wasTempoRealAtivo = !!this.state.tempoRealAtivo;

    // 1) Parar TODOS os timers do anel anterior para evitar conflitos
    if (this.tempoRealId) {
      clearInterval(this.tempoRealId);
      this.tempoRealId = 0;
    }
    if (this.intermitenteId) {
      clearInterval(this.intermitenteId);
      this.intermitenteId = 0;
    }
    if (this.intermitenteHeartbeatId) {
      clearInterval(this.intermitenteHeartbeatId);
      this.intermitenteHeartbeatId = 0;
    }
    if (this.intermitenteNextTimeoutId) {
      clearTimeout(this.intermitenteNextTimeoutId);
      this.intermitenteNextTimeoutId = 0;
    }
    if (this.nIntervId) {
      clearInterval(this.nIntervId);
      this.nIntervId = 0;
    }

    this.setState(
      {
        dataAnel: selectedOption.value,
        dataControlador: selectedOption.id,
        loop: 0,
        tempoRealAtivo: wasTempoRealAtivo,
        list: [],
        tableUpdateKey: Date.now(),
        show: wasTempoRealAtivo,
      },
      async () => {
        try {
          // 2) Buscar estado do controlador UMA VEZ (usado para plano real, labels, tipo_ciclo)
          let stepData = null;
          let d0 = {};
          if (wasTempoRealAtivo || (parseInt(this.state.dataPlano) >= 49 && parseInt(this.state.dataPlano) <= 63)) {
            try {
              const resultStep = await this.props.getControllerStep(
                this.state.dataNumControlador,
                selectedOption.value,
                this.state.dataGrupo,
              );
              if (resultStep && resultStep.payload && resultStep.payload.data && resultStep.payload.data.length > 0) {
                stepData = resultStep.payload.data;
                const anelSelecionado = parseInt(selectedOption.value);
                const itemDoAnel = stepData.find(item => parseInt(item.anel) === anelSelecionado);
                d0 = itemDoAnel || stepData[0] || {};
              }
            } catch (_) {}
          }

          // 3) Determinar o plano real para carregar intervalos (nunca o 63 virtual)
          let planoIdParaCarregar = parseInt(this.state.dataPlano) || 1;
          if (planoIdParaCarregar >= 49 && planoIdParaCarregar <= 63 && d0) {
            const fontes = [d0.plano_ant, d0.plano_pro, d0.plano_atu];
            for (const fonte of fontes) {
              if (!fonte) continue;
              const match = String(fonte).match(/^(\d+)\s*-/);
              if (!match) continue;
              const id = parseInt(match[1]);
              if (id > 0 && id < 49) {
                planoIdParaCarregar = id;
                break;
              }
            }
          }
          if (planoIdParaCarregar >= 49) planoIdParaCarregar = 1;

          // 4) Carregar intervalos do plano real
          const result = await this.props.getList(selectedOption.id, planoIdParaCarregar, selectedOption.value);
          if (!this._isMounted || !result || !result.payload || !result.payload.data) return;

          let newData = JSON.parse(JSON.stringify(result.payload.data));

          // Injeta a linha TH (Tempo de Headway) se for modo adaptativo (6 ou 7) e ela não existir
          const modoOperacaoId = parseInt(newData[0].modo_operacao_id) || 0;
          if ([6, 7].includes(modoOperacaoId)) {
            const hasTH = newData.some(row => row.descricao === 'TH');
            if (!hasTH) {
              const templateRow = newData.find(row => row.descricao === 'ND');
              if (templateRow) {
                const thRow = { ...templateRow, descricao: 'TH' };
                Object.keys(thRow).forEach(key => {
                  if (key.startsWith('col_')) thRow[key] = 0;
                });
                newData.push(thRow);
              }
            }
          }

          const { linhasExibidas } = this._filtrarEOrdenarLinhas(newData);

          // 5) Determinar tipo_ciclo, labels e título usando flags do controlador
          let tipoCicloAtualizado = (d0 && d0.tipo_ciclo) || (newData[0] && newData[0].tipo_ciclo) || '';
          let planoAntLabel = (d0 && d0.plano_ant) || '';
          let planoAtuLabel = (d0 && d0.plano_atu) || '';
          let planoProLabel = (d0 && d0.plano_pro) || '';
          let titulo = this.formatarTitulo(this.state.dataNumControlador, selectedOption.value, planoIdParaCarregar);

          const isPlanoForcado = !!(d0 && d0.plano_forcado);
          const planoForcadoIdHw = parseInt(d0 && d0.plano_forcado_id_hw) || 0;
          const isIntermitente =
            (d0 && d0.mod_piscante) || (d0 && parseInt(d0.plano_id) >= 49 && parseInt(d0.plano_id) <= 63);

          if (isPlanoForcado && planoForcadoIdHw === 32) {
            titulo = `Controlador ${this.state.dataNumControlador} - Anel ${selectedOption.value} - Plano Apagado`;
          } else if (isPlanoForcado && !isIntermitente) {
            titulo = `Controlador ${this.state.dataNumControlador} - Anel ${selectedOption.value} - Plano Forçado`;
          }
          if (isIntermitente) {
            titulo = `Controlador ${this.state.dataNumControlador} - Anel ${selectedOption.value} - Intermitente`;
            if (!tipoCicloAtualizado) tipoCicloAtualizado = 'Intermitente';
          }

          // Buscar grade de troca de planos para o novo anel (labels com descrições)
          if (wasTempoRealAtivo && !(d0 && d0.plano_forcado)) {
            this.props
              .getGradePlanos(selectedOption.id)
              .then(gradeResult => {
                if (!this._isMounted) return;
                if (gradeResult && gradeResult.payload && gradeResult.payload.data) {
                  const grade = gradeResult.payload.data;
                  this._gradeCache = grade;
                  this.setState({
                    planoAnteriorLabel: grade.anterior || planoAntLabel,
                    planoAtualLabel: grade.atual || planoAtuLabel,
                    planoProximoLabel: grade.proximo || planoProLabel,
                  });
                }
              })
              .catch(() => {});
          }

          // 6) Atualizar diagrama e labels
          this.handleDataChange(
            linhasExibidas,
            {
              tableUpdateKey: Date.now(),
              show: false,
              titulo,
              modo: (newData[0] && newData[0].modo_operacao) || '',
              tipoCiclo: tipoCicloAtualizado,
              defasagem: (newData[0] && newData[0].defasagem) || 0,
              tempoDecorrido: (newData[0] && newData[0].decorrente_ciclo) || 0,
              planoAnteriorLabel: planoAntLabel,
              planoAtualLabel: planoAtuLabel,
              planoProximoLabel: planoProLabel,
            },
            () => {
              this.atualizarCamposFormulario(newData);

              // 7) Se estava em tempo real, retomar para o novo anel
              if (wasTempoRealAtivo && this._isMounted) {
                const isPiscaChave = stepData && stepData.some(item => item.modo_operacao === 'Pisca Chave');

                if (isPiscaChave) {
                  this.executaPiscaChave(stepData);
                } else if (isIntermitente) {
                  this.executaIntermitente(stepData);
                } else {
                  this.setState({ loop: 0, tempoRealAtivo: true }, () => this.executaTempoReal());
                }
              }
            },
          );
        } catch (error) {
          console.error('Erro ao mudar anel:', error);
          if (this._isMounted) {
            toastr.error('Erro', 'Falha ao carregar dados do anel.');
          }
        }
      },
    );
  }

  atualizarCamposFormulario(data) {
    if (!this._isMounted || !data || data.length === 0) return;

    const planoDados = data[0];

    if (planoDados.ciclo_maximo !== undefined) {
      window.$('input[name="ciclo_maximo"]').val(planoDados.ciclo_maximo);
    }
    if (planoDados.ciclo_tempo_total !== undefined) {
      window.$('input[name="ciclo_tempo_total"]').val(planoDados.ciclo_tempo_total);
    }
    if (planoDados.defasagem !== undefined) {
      window.$('input[name="defasagem"]').val(planoDados.defasagem);
    }

    this.setState({
      modo: planoDados.modo_operacao || '',
      tipoCiclo: planoDados.tipo_ciclo || '',
      defasagem: planoDados.defasagem || 0,
      tempoDecorrido: planoDados.decorrente_ciclo || 0,
    });

    window.$('#totalCiclo').val(planoDados.ciclo_tempo_total || 0);
  }

  handleDataChange(data, extraState = {}, callback = () => {}) {
    if (this._isMounted) {
      const inferredPlanoApagado = !!(data && data.length > 0 && data[0].is_plano_apagado);
      this.setState(
        {
          list: data,
          controladorSalvo: false,
          sistemaSalvo: false,
          chageChave: true,
          planoApagado: inferredPlanoApagado,
          ...extraState,
        },
        callback,
      );
    }
  }

  render() {
    const intervalo = this.state.list.length > 0 ? this.state.list : this.props.list || [];
    if (!intervalo.length) return <div />;

    const modoOperacaoId = parseInt(intervalo[0].modo_operacao_id) || 0;

    const linhasExibidas = this.state.list;

    const { faseIni, faseFin } = intervalo[0];
    intervalo[0].ciclo_tempo_total = IntervaloValidacao.somaCicloTempoTotal(intervalo);

    const columns = this.carregaColunas();
    const required = value => (value ? undefined : 'Obrigatório');

    const { config } = this.props;
    const usa_adaptativo = config && config.usa_adaptativo;
    const modosSemDefasagem = [0, 1, 2, 6];
    if (!usa_adaptativo) {
      modosSemDefasagem.push(7);
    }

    return (
      <div>
        <Modal
          show={this.state.showLegendModal}
          onHide={this.handleCloseLegendModal.bind(this)}
          dialogClassName="modal-legend"
          backdrop={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Legendas das Siglas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li>
                <strong>TpN:</strong> Tempo Normal
              </li>
              <li>
                <strong>TpM:</strong> Tempo de Mínimo
              </li>
              <li>
                <strong>ND:</strong> Número do Detector
              </li>
              <li>
                <strong>SL:</strong> Sequência Lógica
              </li>
              <li>
                <strong>TE:</strong> Tempo de Extensão
              </li>
              <li>
                <strong>TME:</strong> Tempo Máximo de Extensão
              </li>
              <If condicao={this.props.config.usa_adaptativo}>
                <li>
                  <strong>TH:</strong> Tempo de Headway
                </li>
              </If>
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" className="btn btn-default" onClick={this.handleCloseLegendModal.bind(this)}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-load" backdrop={false}>
          <Modal.Body className="modal-body modal-load-body">
            <ReactLoading type="spokes" color="#367fa9" height={50} width={50} />
            <h4>
              <b>Aguarde, processando...</b>
            </h4>
          </Modal.Body>
        </Modal>
        <div ref={this.componentRef}>
          <div className="plano-config-main-card">
            <div className="box-header">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ flex: '1' }}>
                  <h5 id="titulointervaloplano" className="box-title">
                    {this.state.titulo}
                  </h5>
                  <br />
                  <b>Modo operação:</b>{' '}
                  <span id="modooperacaointervaloplano">
                    {this.state.modOperacaoDesc[intervalo[0].modo_operacao_id]}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                  }}
                >
                  <ButtonTooltip
                    type="button"
                    icon="print"
                    label=""
                    data-title="Imprimir Plano"
                    onClick={() => this.generateReportProgramacao(this.state.dataPlano)}
                  />
                </div>
              </div>
            </div>
            <div className="box box-default">
              <div className="box-body">
                <Row style={{ paddingTop: '10px' }}>
                  <Grid cols="12">{this.exibeImagem(faseIni, faseFin)}</Grid>
                  <Grid cols="12" className="grid-spacing-top">
                    <If condicao={this.state.tempoRealAtivo}>
                      <Grid cols="12">
                        <h5 className="mod_operacao_h4">
                          <b>Plano Anterior: </b>
                          {this.state.planoAnteriorLabel || intervalo[0].plano_ant}
                        </h5>
                        <h5 className="mod_operacao_h4">
                          <b>Plano Atual: </b> {this.state.planoAtualLabel || intervalo[0].plano_atu}
                        </h5>
                        <h5 className="mod_operacao_h4">
                          <b>Próximo Plano: </b> {this.state.planoProximoLabel || intervalo[0].plano_pro}
                        </h5>
                        <h5 className="mod_operacao_h4">
                          <b>Tipo do Ciclo: </b> {this.state.tipoCiclo || (intervalo[0] && intervalo[0].tipo_ciclo)}
                        </h5>
                      </Grid>
                    </If>
                  </Grid>
                </Row>

                <div className="row" style={{ paddingTop: '10px' }}>
                  <div className="col-xs-12 col-sm-1">
                    <SelectConfAnel value={this.state.dataAnel} onChange={this.onChangeAnel} />
                  </div>
                  <div className="col-xs-12 col-sm-1">
                    <label style={{ fontSize: '13px', fontWeight: '600' }}>T. Ciclo</label>
                    <input
                      id="decorrido"
                      type="text"
                      className="form-control input-decorrido"
                      readOnly
                      value={this.state.tempoDecorrido}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-1">
                    <label style={{ fontSize: '13px', fontWeight: '600' }}>T. Intervalo</label>
                    <input
                      id="cronometro"
                      type="text"
                      className="form-control input-cronometro"
                      readOnly
                      value={this.state.cronometroTpN}
                    />
                  </div>
                  <If condicao={[6, 7].includes(parseInt(intervalo[0] && intervalo[0].modo_operacao_id))}>
                    <div className="col-xs-12 col-sm-1">
                      <label style={{ fontSize: '13px', fontWeight: '600' }}>T. Extensão</label>
                      <input
                        id="tempo_total_intervalo"
                        type="text"
                        className="form-control input-decorrido"
                        readOnly
                        value={this.state.cronometroExtensao}
                      />
                    </div>
                  </If>
                </div>

                <div className="row">
                  <div className="col-xs-12 col-sm-2">
                    <Button
                      type="button"
                      id="btnSimular"
                      className="success"
                      style={{ marginTop: '3px', marginLeft: 0, width: '100%' }}
                      icon="play"
                      label="Simular Local"
                      disabled={this.state.disabledbtnSimula}
                      data-title="Simular execução do anel"
                      onClick={this.iniciaSimulacao}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-2">
                    <PermissaoUsuario tela="CadIntervaloPlano" campo="simular_tempo_real" condicao={true}>
                      <ButtonTooltip
                        type="button"
                        id="btnTempoReal"
                        className="info"
                        style={{ marginTop: '3px', marginLeft: 0, width: '100%' }}
                        icon="play"
                        label="Tempo Real"
                        disabled={this.state.disabledbtnTempoReal}
                        data-title="Execução do anel em tempo real"
                        onClick={this.iniciaTempoReal}
                      />
                    </PermissaoUsuario>
                  </div>
                </div>
              </div>
            </div>

            <div className="plano-config-table-wrap">
              <div className="table-container plano-config-table">
                <ReactTableGT2A
                  data={linhasExibidas}
                  columns={columns}
                  defaultPageSize={linhasExibidas.length}
                  showPagination={false}
                  sortable={false}
                  key={`plano-table-${this.state.dataPlano}-${this.state.dataAnel}-${this.state.tableUpdateKey}`}
                />
              </div>
            </div>

            <div className="row plano-config-cycle-fields" style={{ padding: '10px' }}>
              <div className="col-xs-12 col-sm-1">
                <label style={{ fontSize: '13px', fontWeight: '600' }}>Ciclo Total</label>
                <input
                  name="ciclo_tempo_total"
                  type="number"
                  className="form-control"
                  readOnly
                  value={intervalo[0].ciclo_tempo_total}
                />
              </div>
              <div className="col-xs-12 col-sm-1">
                <label style={{ fontSize: '13px', fontWeight: '600' }}>Ciclo Máx.</label>
                <input
                  name="ciclo_maximo"
                  type="number"
                  className="form-control"
                  value={intervalo[0].ciclo_maximo}
                  onChange={this.inputChange}
                  onBlur={this.cicloMaximoOnBlur}
                  readOnly={validaPermissaoReadOnly('CadIntervaloPlano', 'ciclo_maximo_defasagem')}
                />
              </div>
              {/* Conditionally render Defasagem based on modoOperacaoId */}
              <If condicao={!modosSemDefasagem.includes(modoOperacaoId)}>
                <div className="col-xs-12 col-sm-1">
                  <label style={{ fontSize: '13px', fontWeight: '600' }}>Defasagem</label>
                  <input
                    name="defasagem"
                    type="number"
                    className="form-control"
                    value={intervalo[0].defasagem}
                    onChange={this.inputChange}
                    readOnly={validaPermissaoReadOnly('CadIntervaloPlano', 'ciclo_maximo_defasagem')}
                    onBlur={e => {
                      if (!this._isMounted) return;
                      const data = [...intervalo];
                      let valor = parseInt(e.target.value) || 0;
                      let ciclo_tempo_maximo = data[0].ciclo_tempo_total;
                      if (valor < 0) valor = 0;
                      if (valor >= ciclo_tempo_maximo) valor = ciclo_tempo_maximo - 1;
                      for (let key in data) {
                        data[key][e.target.name] = valor;
                      }
                      this.handleDataChange(data);
                    }}
                  />
                </div>
              </If>
              {/* <div className="col-xs-12 col-sm-1">
              <label style={{ fontSize: "13px;", fontWeight: "600" }}>
                Headway
              </label>
              <input
                name="atuado_var"
                type="number"
                className="form-control"
                min="0"
                value={intervalo[0].atuado_var}
                onChange={this.inputChange}
                onBlur={(e) => {
                  if (!this._isMounted) return;
                  const data = [...intervalo];
                  let valor = parseInt(e.target.value) || 0;
                  if (valor < 0) valor = 0;
                  if (valor > 100) valor = 100;
                  for (let key in data) {
                    data[key][e.target.name] = valor;
                  }
                  this.setState({ list: data });
                }}
              />
            </div> */}
            </div>
          </div>

          {/* NOVA SEÇÃO DE OPERAÇÕES COM PLANOS */}
          <div className="box box-default" style={{ marginTop: '20px' }}>
            <div className="box-header with-border">
              <h3 className="box-title">Operações com Planos</h3>
            </div>
            <div className="box-body">
              {/* Linha para SelectPlanoSelect e botão Copiar Plano - Removido style com flex */}
              <div className="row">
                <div className="col-xs-12 col-md-2">
                  <SelectPlanoSelect
                    cols="12"
                    id="selIntervaloCopiaPlano"
                    label="Plano para copiar"
                    data-controlador-id={intervalo[0].controlador_id}
                    data-modo-operacao-id={intervalo[0].modo_operacao_id}
                    disabled={validaPermissaoDisabled('CadIntervaloPlano', 'plano_copiar_intervalo')}
                  />
                </div>
                <div className="col-xs-12 col-md-2" style={{ marginTop: '25px' }}>
                  {' '}
                  {/* Restaurado marginTop para tentativa de alinhamento manual */}
                  <PermissaoUsuario tela="CadIntervaloPlano" campo="plano_copiar_intervalo" condicao={true}>
                    <Button
                      type="button"
                      id="btnCopiarPlano"
                      className="btn-primary" // Cor: Sistema
                      style={{ width: '100%' }}
                      icon="copy"
                      label="Copiar plano"
                      disabled={this.state.disabledbtn}
                      data-title="Copiar intervalo do plano selecionado para o plano atual"
                      onClick={this.copiarPlano}
                    />
                  </PermissaoUsuario>
                  <PermissaoUsuario tela="CadIntervaloPlano" campo="plano_copiar_intervalo" condicao={false}>
                    <Button
                      type="button"
                      className="btn-primary" // Cor: Sistema
                      style={{ width: '100%' }}
                      icon="copy"
                      label="Copiar plano"
                      disabled
                    />
                  </PermissaoUsuario>
                </div>
              </div>

              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-xs-12 col-sm-6 col-md-2">
                  <PermissaoUsuario tela="CadIntervaloPlano" campo="ler_sistema" condicao={true}>
                    <Button
                      type="button"
                      id="btnLerPlanoDB"
                      className="btn-primary" // Cor: Sistema
                      style={{ width: '100%' }}
                      icon="file-download"
                      label="Ler do Sistema"
                      disabled={this.state.disabledbtn}
                      data-title="Busca os dados do banco de dados do sistema"
                      onClick={this.lerPlanoDB}
                    />
                  </PermissaoUsuario>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-2">
                  <PermissaoUsuario tela="CadIntervaloPlano" campo="ler_controlador" condicao={true}>
                    <Button
                      type="button"
                      id="btnLerControlador"
                      className={this.state.verificacaoControladorPendente ? 'info' : 'warning'}
                      style={{
                        width: '100%',
                        ...(this.state.verificacaoControladorPendente
                          ? {
                              animation: 'intervalo-verificacao-pulse 1.85s ease-in-out infinite',
                              fontWeight: 600,
                            }
                          : {}),
                      }}
                      icon="download"
                      label="Ler do Controlador"
                      disabled={this.state.disabledbtn}
                      data-title={
                        this.state.verificacaoControladorPendente
                          ? 'Obrigatório após enviar ao controlador: confirme o que gravou no equipamento.'
                          : 'Busca os dados do controlador'
                      }
                      onClick={this.lerPlanoControlador}
                    />
                  </PermissaoUsuario>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-2">
                  <If condicao={!this.state.disabledbtnplano}>
                    <PermissaoUsuario tela="CadIntervaloPlano" campo="ativar_plano_intermitente" condicao={true}>
                      <Button
                        type="button"
                        id="btnAtivarPlanoIntermitenteControlador"
                        className="btn-warning" // Cor: Controlador
                        style={{ width: '100%' }}
                        icon="toggle-on" // Ícone mais sugestivo
                        label="Ativar Intermitente"
                        disabled={this.state.disabledbtn}
                        data-title="Ativar Plano Intermitente nos controladores"
                        onClick={this.ativarPlanoIntermitente}
                      />
                    </PermissaoUsuario>
                  </If>
                  <If condicao={this.state.disabledbtnplano}>
                    <Button
                      type="button"
                      id="btnDesativarPlanoIntermitenteControlador"
                      className="btn-default" // Cor: Neutra/Reversão
                      style={{ width: '100%' }}
                      icon="toggle-off"
                      label="Desativar Intermitente"
                      disabled={this.state.disabledbtn}
                      data-title="Desativar Plano Intermitente nos controladores"
                      onClick={this.desativarPlanoIntermitente}
                    />
                  </If>
                </div>
              </div>
            </div>
          </div>

          {/* SEÇÃO DE AÇÕES FINAIS — avisos junto aos botões */}
          <div
            className="box-footer"
            style={{
              marginTop: '20px',
              display: 'block',
              paddingTop: '14px',
              borderTop: '1px solid #e8ecf1',
              background: 'linear-gradient(180deg, #fafbfc 0%, #fff 28%)',
            }}
          >
            <style>{`
              @keyframes intervalo-verificacao-pulse {
                0%, 100% { box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.5); }
                50% { box-shadow: 0 0 0 8px rgba(14, 165, 233, 0.12); }
              }
            `}</style>
            {(this.state.envioControladorErro || this.state.verificacaoControladorPendente) && (
              <div style={{ marginBottom: 14, width: '100%', maxWidth: '100%' }}>
                {this.state.envioControladorErro && (
                  <div
                    role="alert"
                    style={{
                      borderRadius: 14,
                      border: '1px solid rgba(239, 68, 68, 0.45)',
                      background: 'linear-gradient(145deg, #fff1f2 0%, #fffbeb 55%, #fefce8 100%)',
                      padding: '16px 18px',
                      marginBottom: this.state.verificacaoControladorPendente ? 12 : 0,
                      boxShadow: '0 8px 28px rgba(185, 28, 28, 0.08)',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: 12,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ flex: '1 1 280px' }}>
                        <div
                          style={{
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.02em',
                            color: '#991b1b',
                            marginBottom: 8,
                          }}
                        >
                          Falha no envio ao controlador
                        </div>
                        <div style={{ fontSize: '13px', lineHeight: 1.55, color: '#451a03' }}>
                          {this.state.envioControladorErro}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-default btn-sm"
                        style={{ whiteSpace: 'nowrap', borderRadius: 8 }}
                        onClick={this.dismissEnvioControladorErro}
                      >
                        Dispensar aviso
                      </button>
                    </div>
                  </div>
                )}
                {this.state.verificacaoControladorPendente && (
                  <div
                    role="status"
                    style={{
                      borderRadius: 14,
                      border: '1px solid rgba(14, 165, 233, 0.35)',
                      background: 'linear-gradient(135deg, #ecfeff 0%, #f0f9ff 40%, #eef2ff 100%)',
                      padding: '16px 18px',
                      boxShadow: '0 10px 32px rgba(15, 118, 110, 0.07)',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                      <span
                        aria-hidden
                        style={{
                          flexShrink: 0,
                          width: 36,
                          height: 36,
                          borderRadius: 10,
                          background: 'linear-gradient(145deg, #0ea5e9, #6366f1)',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 18,
                          fontWeight: 700,
                        }}
                      >
                        ✓
                      </span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: '14px',
                            fontWeight: 700,
                            letterSpacing: '0.03em',
                            color: '#0c4a6e',
                            marginBottom: 6,
                          }}
                        >
                          Conferência obrigatória no equipamento
                        </div>
                        <p style={{ margin: 0, fontSize: '13px', lineHeight: 1.55, color: '#334155' }}>
                          Use <strong>Ler do Controlador</strong> na seção <strong>Operações com Planos</strong> (acima)
                          como <strong> medida de segurança</strong> e confira se o plano foi gravado corretamente.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
              <PermissaoUsuario tela="CadIntervaloPlano" condicao={true}>
                <Button
                  type="button"
                  className="btn btn-info" // Cor: Controlador
                  style={{ minWidth: '180px' }} // Aumentado para novo label
                  icon="upload" // Ícone de enviar para o controlador
                  label="Salvar no Controlador"
                  disabled={this.state.disabledbtn || this.state.controladorSalvo || !this.state.sistemaSalvo}
                  data-title="Salva os dados no banco e envia ao controlador (requer salvar no sistema primeiro)"
                  onClick={this.salvaIntervalo}
                />
                <Button
                  type="button"
                  className="btn btn-success" // Cor: Sistema
                  icon="save" // Ícone save genérico
                  label="Salvar no Sistema"
                  disabled={this.state.disabledbtn || this.state.sistemaSalvo}
                  data-title="Salva os dados no banco de dados"
                  onClick={this.salvaIntervaloDB}
                />
              </PermissaoUsuario>
              <Button
                type="button"
                className="btn btn-default"
                style={{ minWidth: '100px' }}
                icon="close"
                label="Fechar"
                onClick={this.tentativaFecharPlano}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.intervaloPlanoCad.list,
  config: state.auth.config,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getList,
      update,
      initPlano,
      getListInterval,
      updateSerial,
      updatePlano,
      getControllerStep,
      getGradePlanos,
      sendForced,
      sendForcedSemSalvar,
      sendForcedComSalvar,
      sendCancelForced,
      getPlanosAgendados,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntervaloPlanoList);
